jsonpRcsMcWidFunction([7],{

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_grid_system__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_grid_system___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_grid_system__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_rcs_gaz_mc_core_FE__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_rcs_gaz_mc_core_FE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_rcs_gaz_mc_core_FE__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_configManager_configManager__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_Label__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_CorriereLink__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_IconFont__ = __webpack_require__(200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CalendarCorriereWidget=function(_Component){_inherits(CalendarCorriereWidget,_Component);function CalendarCorriereWidget(props){_classCallCheck(this,CalendarCorriereWidget);var _this=_possibleConstructorReturn(this,(CalendarCorriereWidget.__proto__||Object.getPrototypeOf(CalendarCorriereWidget)).call(this,props));_this.getChildContext=function(){return{breakpoints:[320,600,1024,1440]};};_this.getCalendar=function(){var _this$props=_this.props,competitionId=_this$props.competitionId,sportId=_this$props.sportId,day=_this$props.day,actions=_this$props.actions;if(day){actions.getCorriereDayCalendar(sportId,competitionId,day);}else{actions.getCorriereCalendar(sportId,competitionId);}};_this.resizeCallback=function(){_this.setState({isMobile:window.innerWidth<=767});};_this.scrollRightSmooth=function(container){var element=document.querySelector(container);var scrollAmount=0;var slideTimer=setInterval(function(){element.scrollLeft+=7;scrollAmount+=7;if(scrollAmount>=154){window.clearInterval(slideTimer);}},10);};_this.scrollLeftSmooth=function(container){var element=document.querySelector(container);var scrollAmount=0;var slideTimer=setInterval(function(){element.scrollLeft-=7;scrollAmount+=7;if(scrollAmount>=154){window.clearInterval(slideTimer);}},10);};_this.state={isMobile:false//scollingToLeft: 0,
};return _this;}_createClass(CalendarCorriereWidget,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.resizeCallback);var interval=__WEBPACK_IMPORTED_MODULE_5__common_configManager_configManager__["a" /* default */].getSportRefreshInterval(this.props.sportId)?__WEBPACK_IMPORTED_MODULE_5__common_configManager_configManager__["a" /* default */].getSportRefreshInterval(this.props.sportId):60000;this.eventTimer=setInterval(this.getCalendar,interval);this.getCalendar();this.resizeCallback();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.resizeCallback);if(this.eventTimer){clearInterval(this.eventTimer);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,dictionary=_props.dictionary,calendarPre=_props.calendarPre,calendarLive=_props.calendarLive,calendarAfterLive=_props.calendarAfterLive,calendarFull=_props.calendarFull,competitionId=_props.competitionId,sportId=_props.sportId,day=_props.day,calendarDelay=_props.calendarDelay,calendarPost=_props.calendarPost,calendarAbandoned=_props.calendarAbandoned,calendarSuspended=_props.calendarSuspended,_props$isCalendarLoad=_props.isCalendarLoaded,isCalendarLoaded=_props$isCalendarLoad===undefined?false:_props$isCalendarLoad;var finalDay=calendarPre&&calendarPre.get('currentDay')?calendarPre.get('currentDay'):day;var isMobile=this.state.isMobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'10px',backgroundColor:'#fff',maxWidth:'1024px',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["c" /* MainContainerCorriere */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["b" /* DayStripWidgetWrapper */],{isMobile:isMobile},calendarPre&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_grid_system__["Row"],{style:{position:'static',marginTop:'5px',width:isMobile?'100%':'952px',marginLeft:'0px',marginRight:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_grid_system__["Col"],{lg:7,md:7,sm:7,style:{padding:'0px',overflow:'initial'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_shared_Label__["a" /* default */],{label:'TEMPO REALE ',margin:isMobile?'0px 0px 0px 10px':'0 0 16px',font:'BreraCondensedBlack',size:0.9,isCapitalize:true,isTitleNarrowMedium:true,className:'realTimeTitle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+Object(__WEBPACK_IMPORTED_MODULE_4__common_rcs_gaz_mc_core_FE__["prettyCalendarUrl"])(sportId,competitionId,"corriere")+__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */],className:'resetLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_shared_Label__["a" /* default */],{label:dictionary.competitionTable.competitionName[competitionId]+' - '+finalDay+dictionary.competitionTable.dayA,color:'lightBlue2',margin:'0 0 16px',isCapitalize:true,size:0.9}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_grid_system__["Col"],{lg:5,md:5,sm:5,style:{padding:'0px'},className:'flex justifyContentEnd alignItemsCenter'},!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_shared_CorriereLink__["a" /* default */],{color:'linkColor',background:'transparent',label:'Classifica',borderColor:'gray',linkTo:''+Object(__WEBPACK_IMPORTED_MODULE_4__common_rcs_gaz_mc_core_FE__["prettyStandingsUrl"])(sportId,competitionId,"corriere")+__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */],width:'35%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_shared_CorriereLink__["a" /* default */],{color:'linkColor',background:'transparent',label:'Calendario e risultati',borderColor:'gray',linkTo:''+Object(__WEBPACK_IMPORTED_MODULE_4__common_rcs_gaz_mc_core_FE__["prettyCalendarUrl"])(sportId,competitionId,"corriere")+__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */],width:'60%'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_grid_system__["Col"],{lg:12,md:12,sm:12,style:{padding:'0px','min-height':isMobile?'186px':'116px'},className:'flex justifyContentBetween'},!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" /* ArrowContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_shared_IconFont__["a" /* default */],{marginBottom:0.1,marginTop:1.3,className:'icon-matchcenter-arrow',font:23,color:'lightBlue2',withCursor:true,onClick:function onClick(){return _this2.scrollLeftSmooth('.matchWrapperRow');},rotate:'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["d" /* MatchWrapper */],{className:'matchWrapperRow'},isCalendarLoaded&&calendarLive&&calendarLive.get('games')&&calendarLive.get('games').map(function(d){return d&&d.get('matches')&&d.get('matches').map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__["a" /* default */],{matchRow:match,key:index,dictionary:dictionary.competitionTable,isMobile:isMobile,sportId:sportId,competitionId:competitionId,trackString:__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */]});});}),isCalendarLoaded&&calendarAfterLive&&calendarAfterLive.get('games')&&calendarAfterLive.get('games').map(function(d){return d&&d.get('matches')&&d.get('matches').map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__["a" /* default */],{matchRow:match,key:index,dictionary:dictionary.competitionTable,isMobile:isMobile,sportId:sportId,competitionId:competitionId,trackString:__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */]});});}),isCalendarLoaded&&calendarSuspended&&calendarSuspended.get('games')&&calendarSuspended.get('games').map(function(d){return d&&d.get('matches')&&d.get('matches').map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__["a" /* default */],{matchRow:match,key:index,dictionary:dictionary.competitionTable,isMobile:isMobile,sportId:sportId,competitionId:competitionId,trackString:__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */]});});}),isCalendarLoaded&&calendarPre&&calendarPre.get('games')&&calendarPre.get('games').map(function(d){return d&&d.get('matches')&&d.get('matches').map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__["a" /* default */],{matchRow:match,key:index,dictionary:dictionary.competitionTable,isMobile:isMobile,sportId:sportId,competitionId:competitionId,trackString:__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */]});});}),isCalendarLoaded&&calendarDelay&&calendarDelay.get('games')&&calendarDelay.get('games').map(function(d){return d&&d.get('matches')&&d.get('matches').map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__["a" /* default */],{matchRow:match,key:index,dictionary:dictionary.competitionTable,isMobile:isMobile,sportId:sportId,competitionId:competitionId,trackString:__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */]});});}),isCalendarLoaded&&calendarAbandoned&&calendarAbandoned.get('games')&&calendarAbandoned.get('games').map(function(d){return d&&d.get('matches')&&d.get('matches').map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__["a" /* default */],{matchRow:match,key:index,dictionary:dictionary.competitionTable,isMobile:isMobile,sportId:sportId,competitionId:competitionId,trackString:__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */]});});}),isCalendarLoaded&&calendarFull&&calendarFull.get('games')&&calendarFull.get('games').map(function(d){return d&&d.get('matches')&&d.get('matches').map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__["a" /* default */],{matchRow:match,key:index,dictionary:dictionary.competitionTable,isMobile:isMobile,sportId:sportId,competitionId:competitionId,trackString:__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */]});});}),isCalendarLoaded&&calendarPost&&calendarPost.get('games')&&calendarPost.get('games').map(function(d){return d&&d.get('matches')&&d.get('matches').map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MatchRowBoxed__["a" /* default */],{matchRow:match,key:index,dictionary:dictionary.competitionTable,isMobile:isMobile,sportId:sportId,competitionId:competitionId,trackString:__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */]});});}))),isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_grid_system__["Row"],{style:{position:'absolute',bottom:'15px',width:'100%','min-height':'5px'},className:'flex justifyContentCenter alignItemsCenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_grid_system__["Col"],{lg:6,md:6,sm:6,style:{padding:'0px'},className:'flex justifyContentCenter alignItemsCenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_shared_CorriereLink__["a" /* default */],{color:'linkColor',background:'transparent',label:'Classifica',borderColor:'gray',linkTo:''+Object(__WEBPACK_IMPORTED_MODULE_4__common_rcs_gaz_mc_core_FE__["prettyStandingsUrl"])(sportId,competitionId,"corriere")+__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */],isBottomLink:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_grid_system__["Col"],{lg:6,md:6,sm:6,style:{padding:'0px'},className:'flex justifyContentCenter alignItemsCenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_shared_CorriereLink__["a" /* default */],{color:'linkColor',background:'transparent',label:'Calendario',borderColor:'gray',linkTo:''+Object(__WEBPACK_IMPORTED_MODULE_4__common_rcs_gaz_mc_core_FE__["prettyCalendarUrl"])(sportId,competitionId,"corriere")+__WEBPACK_IMPORTED_MODULE_9__constants__["_88" /* TRACK_STRING_CONST */],isBottomLink:true}))))),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles__["a" /* ArrowContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-arrow',font:23,color:'lightBlue2',withCursor:true,onClick:function onClick(){return _this2.scrollRightSmooth('.matchWrapperRow');},marginTop:2.4,paddingRight:'3px'}))));}}]);return CalendarCorriereWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CalendarCorriereWidget.childContextTypes={breakpoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number)};CalendarCorriereWidget.propTypes={actions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,dictionary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,competitionId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,sportId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,day:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendarPre:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendarLive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendarAfterLive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendarFull:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendarDelay:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendarPost:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendarAbandoned:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendarSuspended:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isCalendarLoaded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{dictionary:state.dictionaryReducer.dictionary,calendarPre:state.calendarReducer.get('calendarPre'),calendarLive:state.calendarReducer.get('calendarLive'),calendarAfterLive:state.calendarReducer.get('calendarAfterLive'),calendarFull:state.calendarReducer.get('calendarFull'),calendarDelay:state.calendarReducer.get('calendarDelay'),calendarPost:state.calendarReducer.get('calendarPost'),calendarAbandoned:state.calendarReducer.get('calendarAbandoned'),calendarSuspended:state.calendarReducer.get('calendarSuspended'),isCalendarLoaded:state.calendarReducer.get('isCalendarLoaded')};},function(dispatch){return{actions:{initDictionary:function initDictionary(){return dispatch({type:__WEBPACK_IMPORTED_MODULE_9__constants__["_63" /* INIT_DICTIONARY */]});},getCorriereCalendar:function getCorriereCalendar(sportId,competitionId){return dispatch({type:__WEBPACK_IMPORTED_MODULE_9__constants__["x" /* GET_CALENDAR_CORRIERE_REQUEST */],sportId:sportId,competitionId:competitionId});},getCorriereDayCalendar:function getCorriereDayCalendar(sportId,competitionId,day){return dispatch({type:__WEBPACK_IMPORTED_MODULE_9__constants__["M" /* GET_DAY_CALENDAR_CORRIERE_REQUEST */],sportId:sportId,competitionId:competitionId,day:day});}}};})(CalendarCorriereWidget));

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global window */
/* eslint "no-console": "off" */

var getViewPort = function getViewPort() {
  if (typeof window !== 'undefined' && window.innerWidth) {
    return window.innerWidth;
  }
  return null;
};

var screenClasses = exports.screenClasses = ['xs', 'sm', 'md', 'lg', 'xl'];

var defaultBreakpoints = exports.defaultBreakpoints = [576, 768, 992, 1200];

var defaultContainerWidths = exports.defaultContainerWidths = [540, 750, 960, 1140];

var defaultGutterWidth = exports.defaultGutterWidth = 30;

var defaultGridColumns = exports.defaultGridColumns = 12;

var getScreenClass = exports.getScreenClass = function getScreenClass(_ref) {
  var serverSideScreenClass = _ref.serverSideScreenClass,
      breakpoints = _ref.breakpoints;

  var theBreakpoints = breakpoints && breakpoints.length ? breakpoints : defaultBreakpoints;

  var screenClass = serverSideScreenClass || 'xl';

  var viewport = getViewPort();
  if (viewport) {
    screenClass = 'xs';
    if (theBreakpoints[0] && viewport >= theBreakpoints[0]) screenClass = 'sm';
    if (theBreakpoints[1] && viewport >= theBreakpoints[1]) screenClass = 'md';
    if (theBreakpoints[2] && viewport >= theBreakpoints[2]) screenClass = 'lg';
    if (theBreakpoints[3] && viewport >= theBreakpoints[3]) screenClass = 'xl';
  }

  return screenClass;
};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(215),
    isObject = __webpack_require__(199);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(207);
var Label=function Label(_ref){var label=_ref.label,color=_ref.color,size=_ref.size,weight=_ref.weight,margin=_ref.margin,withCursor=_ref.withCursor,lineHeight=_ref.lineHeight,alignSelf=_ref.alignSelf,isTitleNarrowMedium=_ref.isTitleNarrowMedium,noAlign=_ref.noAlign,width=_ref.width,height=_ref.height,textAlignment=_ref.textAlignment,preLabel=_ref.preLabel,isCapitalize=_ref.isCapitalize,block=_ref.block,font=_ref.font,letterSpacing=_ref.letterSpacing,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* LabelWrapper */],{block:block,withCursor:withCursor,color:color,size:size,weight:weight,margin:margin,lineHeight:lineHeight,alignSelf:alignSelf,isTitleNarrowMedium:isTitleNarrowMedium,noAlign:noAlign,width:width,height:height,textAlignment:textAlignment,isCapitalize:isCapitalize,font:font,letterSpacing:letterSpacing,className:className},preLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* PreLabelContainer */],null,preLabel),label);};Label.propTypes={block:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,preLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,weight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,withCursor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noAlign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,lineHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,alignSelf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isTitleNarrowMedium:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,textAlignment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isCapitalize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,font:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,letterSpacing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n    0%   { opacity:','; }\n    50%  { opacity:','; }\n    100% { opacity:','; }\n  '],['\n    0%   { opacity:','; }\n    50%  { opacity:','; }\n    100% { opacity:','; }\n  ']),_templateObject2=_taggedTemplateLiteral(['\n  transform: ',';\n  font-size: ','px;\n  ','\n  ','\n  ','\n  ','\n  color: ',';\n  background: ',';\n  border-radius: ','px;\n  ',';\n  ',';\n  ','\n  ','\n  font-weight: ',';\n  cursor: ',';\n  padding: 0;\n  line-height: ',';\n  ','\n  ','\n  ','\n  &:before {\n    color: ',';\n    ','\n    ','\n    ',';\n    ',';\n  }\n  ',';\n  ','\n'],['\n  transform: ',';\n  font-size: ','px;\n  ','\n  ','\n  ','\n  ','\n  color: ',';\n  background: ',';\n  border-radius: ','px;\n  ',';\n  ',';\n  ','\n  ','\n  font-weight: ',';\n  cursor: ',';\n  padding: 0;\n  line-height: ',';\n  ','\n  ','\n  ','\n  &:before {\n    color: ',';\n    ','\n    ','\n    ',';\n    ',';\n  }\n  ',';\n  ','\n']),_templateObject3=_taggedTemplateLiteral(['\n    margin-right: ',';\n  '],['\n    margin-right: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    margin-left: ',';\n  '],['\n    margin-left: ',';\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    margin-top: ',';\n  '],['\n    margin-top: ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    margin-bottom: ',';\n  '],['\n    margin-bottom: ',';\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    color: ',';\n  '],['\n    color: ',';\n  ']),_templateObject8=_taggedTemplateLiteral(['\n     color: ',';\n  '],['\n     color: ',';\n  ']),_templateObject9=_taggedTemplateLiteral(['\n    color: white !important;\n  '],['\n    color: white !important;\n  ']),_templateObject10=_taggedTemplateLiteral(['\n    opacity: ',';\n  '],['\n    opacity: ',';\n  ']),_templateObject11=_taggedTemplateLiteral(['\n    padding: 0;\n  '],['\n    padding: 0;\n  ']),_templateObject12=_taggedTemplateLiteral(['\n    border-bottom: 0 none;\n  '],['\n    border-bottom: 0 none;\n  ']),_templateObject13=_taggedTemplateLiteral(['\n      color: ',';\n    '],['\n      color: ',';\n    ']),_templateObject14=_taggedTemplateLiteral(['\n      color: white !important;\n    '],['\n      color: white !important;\n    ']),_templateObject15=_taggedTemplateLiteral(['\n    animation: ',' 2s linear infinite;\n  '],['\n    animation: ',' 2s linear infinite;\n  ']),_templateObject16=_taggedTemplateLiteral(['\n    padding-right: ',';\n  '],['\n    padding-right: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function rotationBuilder(from,to){var rotation=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject,from,to,from);return rotation;}var IconFont=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].i(_templateObject2,function(props){return props.rotate?'rotate(180deg)':'rotate(0deg)';},function(props){return props.font;},function(props){return props.marginRight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject3,props.marginRight!=='auto'?props.marginRight+'em':props.marginRight);},function(props){return props.marginLeft&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,props.marginLeft!=='auto'?props.marginLeft+'em':''+props.marginLeft);},function(props){return props.marginTop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject5,props.marginTop!=='auto'?props.marginTop+'em':''+props.marginTop);},function(props){return props.marginBottom&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6,props.marginBottom!=='auto'?props.marginBottom+'em':''+props.marginBottom);},function(props){return props.isAvailable?'black':'grey';},function(props){return props.theme.colors[props.bgColor];},function(props){return props.borderRadius;},function(props){return props.color&&props.color.indexOf('#')!==-1&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject7,props.color);},function(props){return props.color&&props.color.indexOf('#')===-1&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject8,props.theme.colors[props.color]);},function(props){return props.isSelected&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject7,props.theme.colors.selectedColor);},function(props){return props.isSelectedFavourites&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject9);},function(props){return props.weight?props.weight+' !important':'normal';},function(props){return props.withCursor?'pointer':'default';},function(props){return props.lineHeight?props.lineHeight+' !important':1;},function(props){return props.opacity&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject10,props.opacity);},function(props){return props.noPadding&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject11);},function(props){return props.noBottom&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject12);},function(props){return props.isAvailable?'black':'rgb(186,186,186)';},function(props){return props.isSelected&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject13,props.theme.colors.selectedColor);},function(props){return props.isSelectedFavourites&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject14);},function(props){return props.color&&props.color.indexOf('#')!==-1&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject13,props.color);},function(props){return props.color&&props.color.indexOf('#')===-1&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject13,props.theme.colors[props.color]);},function(props){return props.pulseEffect&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject15,rotationBuilder(1,0));},function(props){return props.paddingRight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject16,props.paddingRight);});/* harmony default export */ __webpack_exports__["a"] = (IconFont);

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(217);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(201);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenClassRender = exports.Visible = exports.Hidden = exports.Row = exports.Container = exports.Col = undefined;

var _Col2 = __webpack_require__(214);

var _Col3 = _interopRequireDefault(_Col2);

var _Container2 = __webpack_require__(227);

var _Container3 = _interopRequireDefault(_Container2);

var _Row2 = __webpack_require__(229);

var _Row3 = _interopRequireDefault(_Row2);

var _Hidden2 = __webpack_require__(231);

var _Hidden3 = _interopRequireDefault(_Hidden2);

var _Visible2 = __webpack_require__(233);

var _Visible3 = _interopRequireDefault(_Visible2);

var _ScreenClassRender2 = __webpack_require__(235);

var _ScreenClassRender3 = _interopRequireDefault(_ScreenClassRender2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Col = _Col3.default; // Grid

exports.Container = _Container3.default;
exports.Row = _Row3.default;

// Utilities

exports.Hidden = _Hidden3.default;
exports.Visible = _Visible3.default;
exports.ScreenClassRender = _ScreenClassRender3.default;

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lazyload__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assets_player_jpeg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assets_player_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_assets_player_jpeg__);
var flagImg='https://images2.gazzettaobjects.it/matchcenter/static/placeholder/placeholder-shield.svg';var TeamLabel=function TeamLabel(_ref){var title=_ref.title,alt=_ref.alt,label=_ref.label,color=_ref.color,size=_ref.size,weight=_ref.weight,marginLeft=_ref.marginLeft,marginRight=_ref.marginRight,marginTop=_ref.marginTop,isMatchPageInverse=_ref.isMatchPageInverse,isMatchPage=_ref.isMatchPage,withCursor=_ref.withCursor,image=_ref.image,nameteam=_ref.nameteam,font=_ref.font,isPlayer=_ref.isPlayer,isForma=_ref.isForma,isFlag=_ref.isFlag,isWorldCup=_ref.isWorldCup,reverseTitle=_ref.reverseTitle,justifyContent=_ref.justifyContent,isAColumn=_ref.isAColumn,isHeader=_ref.isHeader,width=_ref.width,marginWrapper=_ref.marginWrapper,isStripCalendar=_ref.isStripCalendar,noLogo=_ref.noLogo,textWidth=_ref.textWidth,alignment=_ref.alignment,isUpperCase=_ref.isUpperCase,whiteSpace=_ref.whiteSpace,isCorriereCalendar=_ref.isCorriereCalendar,noFavStar=_ref.noFavStar,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* TeamWrapper */],{withCursor:withCursor,justifyContent:justifyContent,isAColumn:isAColumn,marginWrapper:marginWrapper,className:'boxTeam'},isMatchPageInverse&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TeamName */],{marginLeft:marginLeft,marginRight:marginRight,marginTop:marginTop,color:color,size:size,weight:weight,font:font,textWidth:textWidth,alignment:alignment,whiteSpace:whiteSpace,alt:alt,title:title},label),'    ',image&&!noLogo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a,{height:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* TeamLogo */],{isPlayer:isPlayer,isForma:isForma,isFlag:isFlag,isWorldCup:isWorldCup,isMatchPage:isMatchPage,src:image,onError:function onError(e){e.target.src=isPlayer?__WEBPACK_IMPORTED_MODULE_4__utils_assets_player_jpeg___default.a:flagImg;e.target.className+=' placeholder';},reverseTitle:reverseTitle,isHeader:isHeader,width:width,height:height,className:'logoTeamHeader',isStripCalendar:isStripCalendar,isCorriereCalendar:isCorriereCalendar,noFavStar:noFavStar,alt:nameteam,title:nameteam}))/*(
        <LazyLoad>
          <TeamLogo
            isPlayer={isPlayer}
            isFlag={isFlag}
            src=""
            reverseTitle={reverseTitle}
            isHeader={isHeader}
            width={width}
            className="logoTeamHeader"
            isStripCalendar={isStripCalendar}
          />
        </LazyLoad>
      )*/,!isMatchPageInverse&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TeamName */],{marginLeft:marginLeft,marginRight:marginRight,marginTop:marginTop,color:color,size:size,weight:weight,font:font,textWidth:textWidth,alignment:alignment,isUpperCase:isUpperCase,whiteSpace:whiteSpace,alt:alt,title:title},label));};TeamLabel.propTypes={alt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,justifyContent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,weight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,marginRight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,marginLeft:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,marginTop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,withCursor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,nameteam:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,font:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isPlayer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isForma:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isFlag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,reverseTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isMatchPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isMatchPageInverse:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isAColumn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,marginWrapper:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isStripCalendar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noLogo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,textWidth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alignment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isWorldCup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isUpperCase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,whiteSpace:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isCorriereCalendar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noFavStar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (TeamLabel);

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceVisible = exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(56);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(208);

var _scrollParent = __webpack_require__(209);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(210);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(211);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

/**
 * Forces the component to display regardless of whether the element is visible in the viewport.
 */
var forceVisible = function forceVisible() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    listener.visible = true;
    listener.forceUpdate();
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    // this.setRef = this.setRef.bind(this);
    return _this;
  }

  // setRef(element) {
  //   if (element) {
  //     this.ref = element;
  //   }
  // }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        // const parent = scrollParent(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        // const parent = scrollParent(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
      // <span ref={this.setRef} className="lazyload-custom-placeholder">
      //   {this.props.placeholder}
      // </span> :
      // <div ref={this.setRef} style={{ height: this.props.height }} className="lazyload-placeholder" />;
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

exports.lazyload = decorator;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
exports.forceVisible = forceVisible;

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(16);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PreLabelContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  color: #000000;\n  font-size: 1em;\n  text-align: ',';\n  display: ',';\n  font-family: ',';\n  align-self: ',';\n  line-height: ',';\n  text-transform: ',';\n  width: ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ::selection{\n    background: none;\n  }\n'],['\n  color: #000000;\n  font-size: 1em;\n  text-align: ',';\n  display: ',';\n  font-family: ',';\n  align-self: ',';\n  line-height: ',';\n  text-transform: ',';\n  width: ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ::selection{\n    background: none;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    color: ',';\n  '],['\n    color: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    letter-spacing: ',';\n  '],['\n    letter-spacing: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n  font-size: ','em;\n  '],['\n  font-size: ','em;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    font-weight: ',';\n  '],['\n    font-weight: ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    margin: ','\n  '],['\n    margin: ','\n  ']),_templateObject7=_taggedTemplateLiteral(['\n  font-family: ',';\n  font-weight: bold;\n'],['\n  font-family: ',';\n  font-weight: bold;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LabelWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.textAlignment;},function(props){return props.block?'block':'inline';},function(props){return props.font?props.theme.fontSets[props.font]:props.isTitleNarrowMedium?''+props.theme.fontSets.narrowBold:''+props.theme.fontSets.narrowRegular;},function(props){return props.alignSelf?''+props.alignSelf:'center';},function(props){return props.lineHeight?''+props.lineHeight:1;},function(props){return props.isCapitalize?'uppercase':'normal';},function(props){return props.width;},function(props){return props.color&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,props.theme.colors[props.color]);},function(props){return props.letterSpacing&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject3,props.letterSpacing);},function(props){return props.size&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,props.size);},function(props){return props.weight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject5,props.weight);},function(props){return props.margin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6,props.margin);});var PreLabelContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject7,function(props){return props.theme.fontSets.narrowMedium;});

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TeamWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TeamName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  flex-direction:',';\n  border-radius:',';\n  margin:',';\n  ',';\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  flex-direction:',';\n  border-radius:',';\n  margin:',';\n  ',';\n']),_templateObject2=_taggedTemplateLiteral([' \n    justify-content: ',';\n  '],[' \n    justify-content: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  border-radius:',';\n  height: ',';\n  image-rendering: optimizeSpeed;\n  -ms-interpolation-mode: nearest-neighbor;\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ',';\n  &.placeholder {\n    max-height: 33px;\n  }\n'],['\n  border-radius:',';\n  height: ',';\n  image-rendering: optimizeSpeed;\n  -ms-interpolation-mode: nearest-neighbor;\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ',';\n  &.placeholder {\n    max-height: 33px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: ',';\n    height: auto;\n  '],['\n    width: ',';\n    height: auto;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    height: ',';;\n  '],['\n    height: ',';;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    height: 34px;\n    width: 34px;\n  '],['\n    height: 34px;\n    width: 34px;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    height: 45px;\n  '],['\n    height: 45px;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n    height: 20px;\n    width: 30px;\n  '],['\n    height: 20px;\n    width: 30px;\n  ']),_templateObject9=_taggedTemplateLiteral(['\n    height: 50px;\n  '],['\n    height: 50px;\n  ']),_templateObject10=_taggedTemplateLiteral(['\n    height: 28px;\n    width: 28px;\n  '],['\n    height: 28px;\n    width: 28px;\n  ']),_templateObject11=_taggedTemplateLiteral(['\n    height: 36px;\n  '],['\n    height: 36px;\n  ']),_templateObject12=_taggedTemplateLiteral(['\n    box-shadow: 0px 0px 3px 0 rgba(0,0,0,0.4);\n    padding: 2px;\n    border-radius: 4px;\n    height: 22px;\n    width: 22px;\n  '],['\n    box-shadow: 0px 0px 3px 0 rgba(0,0,0,0.4);\n    padding: 2px;\n    border-radius: 4px;\n    height: 22px;\n    width: 22px;\n  ']),_templateObject13=_taggedTemplateLiteral(['\n    height: 15px;\n    width: 20px;\n  '],['\n    height: 15px;\n    width: 20px;\n  ']),_templateObject14=_taggedTemplateLiteral(['\n  color: ',';\n  font-weight: ',';\n  margin-left: ','em;\n  margin-top: ','px;\n  margin-right: ','em;\n  text-align: ',';\n  font-size: 18px;\n  text-transform: ',';\n  ',';\n  ',';\n  width: ',';\n  ',';\n  text-overflow: ellipsis;\n  overflow: hidden;\n'],['\n  color: ',';\n  font-weight: ',';\n  margin-left: ','em;\n  margin-top: ','px;\n  margin-right: ','em;\n  text-align: ',';\n  font-size: 18px;\n  text-transform: ',';\n  ',';\n  ',';\n  width: ',';\n  ',';\n  text-overflow: ellipsis;\n  overflow: hidden;\n']),_templateObject15=_taggedTemplateLiteral([' \n    font-size: ','px;\n  '],[' \n    font-size: ','px;\n  ']),_templateObject16=_taggedTemplateLiteral(['\n    font-family: ',';\n  '],['\n    font-family: ',';\n  ']),_templateObject17=_taggedTemplateLiteral([' \n    white-space: ',';\n  '],[' \n    white-space: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TeamWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.isAColumn?'column':'row';},function(props){return props.isSquad?'50%':'';},function(props){return props.marginWrapper?props.marginWrapper:'0px';},function(props){return props.justifyContent&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,props.justifyContent);});var TeamLogo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].img(_templateObject3,function(props){return props.isPlayer?'50%':'';},function(props){return props.isMatchPage?'85px':'30px';},function(props){return props.width&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,props.width);},function(props){return props.height&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject5,props.height);},function(props){return props.isPlayer&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6);},function(props){return props.isForma&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject7);},function(props){return props.isFlag&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject8);},function(props){return props.isHeader&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject9);},function(props){return props.isStripCalendar&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject10);},function(props){return props.isWorldCup&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject11);},function(props){return props.isCorriereCalendar&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject12);},function(props){return props.noFavStar&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject13);});var TeamName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject14,function(props){return props.color;},function(props){return props.weight;},function(props){return props.marginLeft;},function(props){return props.marginTop;},function(props){return props.marginRight;},function(props){return props.alignment?props.alignment:'left';},function(props){return props.isUpperCase?'uppercase':'initial';},function(props){return props.size&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject15,props.size);},function(props){return props.font&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject16,props.theme.fontSets[props.font]);},function(props){return props.textWidth?props.textWidth:'auto';},function(props){return props.whiteSpace&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject17,props.whiteSpace);});

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QCMRXhpZgAATU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAACigAwAEAAAAAQAAACkAAAAA/+0AOFBob3Rvc2hvcCAzLjAAOEJJTQQEAAAAAAAAOEJJTQQlAAAAAAAQ1B2M2Y8AsgTpgAmY7PhCfv/AABEIACkAKAMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2wBDAAkGBxQHBhURBw4SFRIXEhIVFREXGBITHBAXFRcWFhcVFhkaHSggGBolGxgVITEiJSkrLi4vFx8zODMtOSgtLiv/2wBDAQoKCgUFBQ4FBQ4rGRMZKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKyv/3QAEAAP/2gAMAwEAAhEDEQA/APYqp6nqC6fBukBJJwAO5xn8BVysDxd/qI/Xc3H4UAVU8TSBvnjQj0G4frW/p18t/b74uOcFT1U+lcJXReETzIP9w4/OgDo6KKKAP//Q9irP1u0F3p7DuoLKfcD/AAqPUdbSykK4LOOoHGPqawNQ1qS9Urwqn+Ed/qe9AGbXYeHbQW+nhv4nwx+nYflXH1fsNWksVxEQVz908j8O4oA7aisnTtdS8kCSKUc9B1BPoD/jWtQB/9HpL1t165P99/5moKlu/wDj6f8A33/9CNRUAFFFFAElucXCkf3l/mK3vPf+8awYP9ev+8v8xW7QB//Z"

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(197);

var _throttle2 = _interopRequireDefault(_throttle);

var _style = __webpack_require__(226);

var _style2 = _interopRequireDefault(_style);

var _utils = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Col = function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Col);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Col.__proto__ || Object.getPrototypeOf(Col)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          xs = _this$props.xs,
          sm = _this$props.sm,
          md = _this$props.md,
          lg = _this$props.lg,
          xl = _this$props.xl,
          offset = _this$props.offset,
          pull = _this$props.pull,
          push = _this$props.push,
          debug = _this$props.debug,
          style = _this$props.style,
          otherProps = _objectWithoutProperties(_this$props, ['children', 'xs', 'sm', 'md', 'lg', 'xl', 'offset', 'pull', 'push', 'debug', 'style']);

      var theStyle = (0, _style2.default)({
        width: {
          xs: xs, sm: sm, md: md, lg: lg, xl: xl
        },
        offset: offset,
        pull: pull,
        push: push,
        debug: debug,
        screenClass: _this.state.screenClass,
        gutterWidth: _this.context.gutterWidth,
        moreStyle: style,
        gridColumns: _this.context.gridColumns
      });
      return _react2.default.createElement(
        'div',
        _extends({ style: theStyle }, otherProps),
        children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Col;
}(_react2.default.Component);

Col.propTypes = {
  /**
   * Content of the column
   */
  children: _propTypes2.default.node,
  /**
   * The width of the column for screenclass `xs`, between 0 and 12
   */
  xs: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `sm`, between 0 and 12
   */
  sm: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `md`, between 0 and 12
   */
  md: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `lg`, between 0 and 12
   */
  lg: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `xl`, between 0 and 12
   */
  xl: _propTypes2.default.number,
  /**
   * The offset of this column for all screenclasses
   */
  offset: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
  * The amount this column is pushed to the right for all screenclasses
  */
  push: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
   * The amount this column is pulled to the left for all screenclasses
   */
  pull: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
   * Optional styling
   */
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  /**
   * Set to apply some debug styling
   */
  debug: _propTypes2.default.bool
};
Col.defaultProps = {
  children: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  offset: {},
  push: {},
  pull: {},
  style: {},
  debug: false
};
Col.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
  gutterWidth: _propTypes2.default.number,
  gridColumns: _propTypes2.default.number
};
exports.default = Col;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(199),
    now = __webpack_require__(216),
    toNumber = __webpack_require__(218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(201);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(219),
    isObject = __webpack_require__(199),
    isSymbol = __webpack_require__(221);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(220);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 220:
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(222),
    isObjectLike = __webpack_require__(225);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(202),
    getRawTag = __webpack_require__(223),
    objectToString = __webpack_require__(224);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(202);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 224:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 225:
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(196);

var hasWidth = function hasWidth(widths) {
  return Object.keys(widths).reduce(function (acc, cur) {
    return acc || widths[cur];
  }, false);
};

var getWidth = function getWidth(width, gridColumns) {
  if (typeof width !== 'number') return undefined;
  var normalizedWidth = Math.max(0, Math.min(gridColumns, width));
  return 100 / gridColumns * normalizedWidth + '%';
};

exports.default = function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === undefined ? {} : _ref$width,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? {} : _ref$offset,
      _ref$pull = _ref.pull,
      pull = _ref$pull === undefined ? {} : _ref$pull,
      _ref$push = _ref.push,
      push = _ref$push === undefined ? {} : _ref$push,
      debug = _ref.debug,
      screenClass = _ref.screenClass,
      gutterWidth = _ref.gutterWidth,
      moreStyle = _ref.moreStyle,
      gridColumns = _ref.gridColumns;

  var theGutterWidth = typeof gutterWidth === 'number' ? gutterWidth : _utils.defaultGutterWidth;
  var theGridColumns = typeof gridColumns === 'number' ? gridColumns : _utils.defaultGridColumns;

  var styles = _extends({
    boxSizing: 'border-box',
    minHeight: '1px',
    position: 'relative',
    paddingLeft: theGutterWidth / 2 + 'px',
    paddingRight: theGutterWidth / 2 + 'px',
    width: '100%',
    overflow: 'hidden'
  }, moreStyle);

  if (debug) {
    styles.outline = '1px solid silver';
    styles.background = 'rgba(0,0,0,.05)';
  }

  styles.flexBasis = '100%';
  styles.flexGrow = 0;
  styles.flexShrink = 0;
  styles.maxWidth = '100%';
  styles.marginLeft = '0%';
  styles.right = 'auto';
  styles.left = 'auto';

  _utils.screenClasses.forEach(function (size, index) {
    if (_utils.screenClasses.indexOf(screenClass) >= index) {
      styles.flexBasis = getWidth(width[size], theGridColumns) || styles.flexBasis;
      styles.maxWidth = getWidth(width[size], theGridColumns) || styles.maxWidth;
      styles.marginLeft = getWidth(offset[size], theGridColumns) || styles.marginLeft;
      styles.right = getWidth(pull[size], theGridColumns) || styles.right;
      styles.left = getWidth(push[size], theGridColumns) || styles.left;
    }
  });

  if (!hasWidth(width)) {
    styles.flexBasis = 0;
    styles.flexGrow = 1;
  }

  return styles;
};

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(197);

var _throttle2 = _interopRequireDefault(_throttle);

var _style = __webpack_require__(228);

var _style2 = _interopRequireDefault(_style);

var _utils = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Container = function (_React$Component) {
  _inherits(Container, _React$Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          fluid = _this$props.fluid,
          xs = _this$props.xs,
          sm = _this$props.sm,
          md = _this$props.md,
          lg = _this$props.lg,
          xl = _this$props.xl,
          style = _this$props.style,
          otherProps = _objectWithoutProperties(_this$props, ['children', 'fluid', 'xs', 'sm', 'md', 'lg', 'xl', 'style']);

      var theStyle = (0, _style2.default)({
        fluid: fluid,
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,
        screenClass: _this.state.screenClass,
        containerWidths: _this.context.containerWidths,
        gutterWidth: _this.context.gutterWidth,
        moreStyle: style
      });
      return _react2.default.createElement(
        'div',
        _extends({ style: theStyle }, otherProps),
        children,
        _react2.default.createElement('span', { style: (0, _style.getAfterStyle)() })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Container;
}(_react2.default.Component);

Container.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * True makes the container full-width, false fixed-width
   */
  fluid: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xs, not present means fluid everywhere
   */
  xs: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in sm, not present means fluid everywhere
   */
  sm: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in md, not present means fluid everywhere
   */
  md: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in lg, not present means fluid everywhere
   */
  lg: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xl, not present means fluid everywhere
   */
  xl: _propTypes2.default.bool,
  /**
   * Optional styling
   */
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))
};
Container.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
  containerWidths: _propTypes2.default.arrayOf(_propTypes2.default.number),
  gutterWidth: _propTypes2.default.number
};
Container.defaultProps = {
  fluid: false,
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  style: {}
};
exports.default = Container;

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAfterStyle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(196);

exports.default = function (_ref) {
  var fluid = _ref.fluid,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      screenClass = _ref.screenClass,
      containerWidths = _ref.containerWidths,
      gutterWidth = _ref.gutterWidth,
      moreStyle = _ref.moreStyle;

  var theContainerWidths = containerWidths && containerWidths.length ? containerWidths : _utils.defaultContainerWidths;
  var theGutterWidth = typeof gutterWidth === 'number' ? gutterWidth : _utils.defaultGutterWidth;

  var styles = _extends({
    boxSizing: 'border-box',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: theGutterWidth / 2 + 'px',
    paddingRight: theGutterWidth / 2 + 'px'
  }, moreStyle);

  if (fluid && !sm && !md && !lg && !xl) {
    return styles;
  }

  if (screenClass === 'sm' && theContainerWidths[0] && !sm && !xs) {
    styles.maxWidth = theContainerWidths[0] + 'px';
  }

  if (screenClass === 'md' && theContainerWidths[1] && !md) {
    styles.maxWidth = theContainerWidths[1] + 'px';
  }

  if (screenClass === 'lg' && theContainerWidths[2] && !lg) {
    styles.maxWidth = theContainerWidths[2] + 'px';
  }

  if (screenClass === 'xl' && theContainerWidths[3] && !xl) {
    styles.maxWidth = theContainerWidths[3] + 'px';
  }

  return styles;
};

var getAfterStyle = exports.getAfterStyle = function getAfterStyle() {
  return {
    display: 'table',
    clear: 'both'
  };
};

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(230);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_React$Component) {
  _inherits(Row, _React$Component);

  function Row() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Row);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Row.__proto__ || Object.getPrototypeOf(Row)).call.apply(_ref, [this].concat(args))), _this), _this.getChildContext = function () {
      return {
        gutterWidth: _this.props.nogutter ? 0 : _this.context.gutterWidth
      };
    }, _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          style = _this$props.style,
          align = _this$props.align,
          debug = _this$props.debug,
          nogutter = _this$props.nogutter,
          otherProps = _objectWithoutProperties(_this$props, ['children', 'style', 'align', 'debug', 'nogutter']);

      var theStyle = (0, _style2.default)({
        gutterWidth: nogutter ? 0 : _this.context.gutterWidth,
        align: align,
        debug: debug,
        moreStyle: style
      });
      return _react2.default.createElement(
        'div',
        _extends({ style: theStyle }, otherProps),
        children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Row;
}(_react2.default.Component);

Row.propTypes = {
  /**
   * Content of the element
   */
  children: _propTypes2.default.node.isRequired,
  /**
  * Column alignment
  */
  align: _propTypes2.default.oneOf(['normal', 'start', 'center', 'end']),
  /**
  * No gutter for this row
  */
  nogutter: _propTypes2.default.bool,
  /**
  * Optional styling
  */
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  /**
    * Set to apply some debug styling
    */
  debug: _propTypes2.default.bool
};
Row.defaultProps = {
  align: 'normal',
  nogutter: false,
  style: {},
  debug: false
};
Row.contextTypes = {
  gutterWidth: _propTypes2.default.number
};
Row.childContextTypes = {
  gutterWidth: _propTypes2.default.number
};
exports.default = Row;

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(196);

exports.default = function (_ref) {
  var gutterWidth = _ref.gutterWidth,
      align = _ref.align,
      debug = _ref.debug,
      moreStyle = _ref.moreStyle;

  var theGutterWidth = typeof gutterWidth === 'number' ? gutterWidth : _utils.defaultGutterWidth;

  var alignItems = align;
  if (align === 'start') alignItems = 'flex-start';
  if (align === 'end') alignItems = 'flex-end';

  var styles = _extends({
    marginLeft: '-' + theGutterWidth / 2 + 'px',
    marginRight: '-' + theGutterWidth / 2 + 'px',
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 0,
    flexShrink: 0,
    alignItems: alignItems
  }, moreStyle);

  if (debug) {
    styles.background = 'rgba(128,128,128,.05)';
  }

  return styles;
};

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(197);

var _throttle2 = _interopRequireDefault(_throttle);

var _style = __webpack_require__(232);

var style = _interopRequireWildcard(_style);

var _utils = __webpack_require__(196);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Hidden = function (_React$Component) {
  _inherits(Hidden, _React$Component);

  function Hidden() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Hidden);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hidden.__proto__ || Object.getPrototypeOf(Hidden)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      if (style.hidden({
        screenClass: _this.state.screenClass,
        xs: _this.props.xs,
        sm: _this.props.sm,
        md: _this.props.md,
        lg: _this.props.lg,
        xl: _this.props.xl
      })) return false;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Hidden;
}(_react2.default.Component);

Hidden.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Hide on extra small devices
   */
  xs: _propTypes2.default.bool,
  /**
   * Hide on small devices
   */
  sm: _propTypes2.default.bool,
  /**
   * Hide on medium devices
   */
  md: _propTypes2.default.bool,
  /**
   * Hide on large devices
   */
  lg: _propTypes2.default.bool,
  /**
   * Hide on xlarge devices
   */
  xl: _propTypes2.default.bool
};
Hidden.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number)
};
Hidden.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false
};
exports.default = Hidden;

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hidden = exports.hidden = function hidden(_ref) {
  var screenClass = _ref.screenClass,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;

  if (screenClass === 'xl') return xl;
  if (screenClass === 'lg') return lg;
  if (screenClass === 'md') return md;
  if (screenClass === 'sm') return sm;
  return xs;
};

exports.default = hidden;

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(197);

var _throttle2 = _interopRequireDefault(_throttle);

var _style = __webpack_require__(234);

var style = _interopRequireWildcard(_style);

var _utils = __webpack_require__(196);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Visible = function (_React$Component) {
  _inherits(Visible, _React$Component);

  function Visible() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Visible);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Visible.__proto__ || Object.getPrototypeOf(Visible)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      if (!style.visible({
        screenClass: _this.state.screenClass,
        xs: _this.props.xs,
        sm: _this.props.sm,
        md: _this.props.md,
        lg: _this.props.lg,
        xl: _this.props.xl
      })) return false;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Visible;
}(_react2.default.Component);

Visible.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Show on extra small devices
   */
  xs: _propTypes2.default.bool,
  /**
   * Show on small devices
   */
  sm: _propTypes2.default.bool,
  /**
   * Show on medium devices
   */
  md: _propTypes2.default.bool,
  /**
   * Show on large devices
   */
  lg: _propTypes2.default.bool,
  /**
   * Show on xl devices
   */
  xl: _propTypes2.default.bool
};
Visible.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number)
};
Visible.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false
};
exports.default = Visible;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var visible = exports.visible = function visible(_ref) {
  var screenClass = _ref.screenClass,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;

  if (screenClass === 'xl') return xl;
  if (screenClass === 'lg') return lg;
  if (screenClass === 'md') return md;
  if (screenClass === 'sm') return sm;
  return xs;
};

exports.default = visible;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(197);

var _throttle2 = _interopRequireDefault(_throttle);

var _utils = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */
/* eslint no-console: off */

var ScreenClassRender = function (_React$Component) {
  _inherits(ScreenClassRender, _React$Component);

  function ScreenClassRender() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScreenClassRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScreenClassRender.__proto__ || Object.getPrototypeOf(ScreenClassRender)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.getStyle = function () {
      return _this.props.style(_this.state.screenClass, _this.props.children.props);
    }, _this.render = function () {
      if (_this.props.render) {
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _this.props.render(_this.state.screenClass)
        );
      }
      if (!_this.warned) {
        console.warn('Please use the render prop of ScreenClassRender. Using style and children is deprecated and will be removed in the next major release.');
        _this.warned = true;
      }
      if (_this.props.style) {
        return _react2.default.cloneElement(_this.props.children, { style: _this.getStyle() });
      }
      return false;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ScreenClassRender;
}(_react2.default.Component);

ScreenClassRender.propTypes = {
  /**
   * Deprecated, will be removed in the next major release
   */
  children: _propTypes2.default.element,
  /**
   * Deprecated, will be removed in the next major release
   */
  style: _propTypes2.default.func,
  /**
   * The function which return value will be rendered.
   * Will be called with one argument: the screen class.
   */
  render: _propTypes2.default.func
};
ScreenClassRender.defaultProps = {
  children: null,
  style: null,
  render: null
};
ScreenClassRender.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number)
};
exports.default = ScreenClassRender;

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(24);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(241);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(242);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(243);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(244);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(245);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(246);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(237);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(206);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(247);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(248);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(249);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(250);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(251);
/* unused harmony reexport withRouter */





























/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(206);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(206);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(57);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(236);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(58);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(59);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(60);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(61);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(25);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(17);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(62);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Label__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconFont__ = __webpack_require__(200);
var LabelLink=function LabelLink(_ref){var label=_ref.label,color=_ref.color,size=_ref.size,path=_ref.path,isInternal=_ref.isInternal,margin=_ref.margin,weight=_ref.weight,hideArrow=_ref.hideArrow,isForm=_ref.isForm,isTitleNarrowMedium=_ref.isTitleNarrowMedium,rotate=_ref.rotate,font=_ref.font;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* LinkWrapper */],{isForm:isForm},isInternal?label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* LabelLinkWrapperInt */],{to:path,rotate:rotate},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Label__["a" /* default */],{color:color,size:size,label:label,weight:weight,isTitleNarrowMedium:isTitleNarrowMedium,font:font}),!hideArrow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__IconFont__["a" /* default */],{className:'icon-matchcenter-right-arrow',color:color,font:10,marginLeft:0.3,weight:'bold',withCursor:true,rotate:rotate})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* LabelLinkWrapperExt */],{href:path,rotate:rotate,margin:margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Label__["a" /* default */],{margin:margin,color:color,size:size,font:font,label:label,weight:weight,isTitleNarrowMedium:isTitleNarrowMedium}),!hideArrow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__IconFont__["a" /* default */],{className:'icon-matchcenter-right-arrow',color:color,font:10,marginLeft:0.3,weight:'bold',withCursor:true,rotate:rotate})));};LabelLink.propTypes={label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isInternal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,weight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hideArrow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isForm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isTitleNarrowMedium:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,rotate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,font:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (LabelLink);

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelLinkWrapperExt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LabelLinkWrapperInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LinkWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(240);
var _templateObject=_taggedTemplateLiteral(['\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  ',';\n  flex-direction: ',';\n  \n'],['\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  ',';\n  flex-direction: ',';\n  \n']),_templateObject2=_taggedTemplateLiteral(['\n    color: ',';\n  '],['\n    color: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  margin: 0em 0.2em 0.2em 0em;\n  ',';\n  flex-direction: ',';\n'],['\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  margin: 0em 0.2em 0.2em 0em;\n  ',';\n  flex-direction: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n     color: ',';\n  '],['\n     color: ',';\n  ']),_templateObject5=_taggedTemplateLiteral(['\n  margin: ',';\n'],['\n  margin: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LabelLinkWrapperExt=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].a(_templateObject,function(props){return props.color&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,props.color);},function(props){return props.rotate?'row-reverse':'row';});var LabelLinkWrapperInt=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject3,function(props){return props.color&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,props.color);},function(props){return props.rotate?'row-reverse':'row';});var LinkWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,function(props){return props.isForm?'0 0.3em 0':'';});

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__(257),
    decode = __webpack_require__(258);

exports.decode = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level) {
    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;

exports.decodeXML = exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__(238)),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__(239)),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function(inverse, name) {
            inverse[obj[name]] = "&" + name + ";";
            return inverse;
        }, {});
}

function getInverseReplacer(inverse) {
    var single = [],
        multiple = [];

    Object.keys(inverse).forEach(function(k) {
        if (k.length === 1) {
            single.push("\\" + k);
        } else {
            multiple.push(k);
        }
    });

    //TODO add ranges
    multiple.unshift("[" + single.join("") + "]");

    return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c) {
    return (
        "&#x" +
        c
            .charCodeAt(0)
            .toString(16)
            .toUpperCase() +
        ";"
    );
}

function astralReplacer(c) {
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    var high = c.charCodeAt(0);
    var low = c.charCodeAt(1);
    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re) {
    function func(name) {
        return inverse[name];
    }

    return function(data) {
        return data
            .replace(re, func)
            .replace(re_astralSymbols, astralReplacer)
            .replace(re_nonASCII, singleCharReplacer);
    };
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data) {
    return data
        .replace(re_xmlChars, singleCharReplacer)
        .replace(re_astralSymbols, astralReplacer)
        .replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__(239),
    legacyMap = __webpack_require__(259),
    xmlMap = __webpack_require__(238),
    decodeCodePoint = __webpack_require__(260);

var decodeXMLStrict = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map) {
    var keys = Object.keys(map).join("|"),
        replace = getReplacer(map);

    keys += "|#[xX][\\da-fA-F]+|#\\d+";

    var re = new RegExp("&(?:" + keys + ");", "g");

    return function(str) {
        return String(str).replace(re, replace);
    };
}

var decodeHTML = (function() {
    var legacy = Object.keys(legacyMap).sort(sorter);

    var keys = Object.keys(entityMap).sort(sorter);

    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        } else {
            keys[i] += ";";
        }
    }

    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
        replace = getReplacer(entityMap);

    function replacer(str) {
        if (str.substr(-1) !== ";") str += ";";
        return replace(str);
    }

    //TODO consider creating a merged map
    return function(str) {
        return String(str).replace(re, replacer);
    };
})();

function sorter(a, b) {
    return a < b ? 1 : -1;
}

function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            if (str.charAt(2) === "X" || str.charAt(2) === "x") {
                return decodeCodePoint(parseInt(str.substr(3), 16));
            }
            return decodeCodePoint(parseInt(str.substr(2), 10));
        }
        return map[str.slice(1, -1)];
    };
}

module.exports = {
    XML: decodeXMLStrict,
    HTML: decodeHTML,
    HTMLStrict: decodeHTMLStrict
};


/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(261);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }

    if (codePoint in decodeMap) {
        codePoint = decodeMap[codePoint];
    }

    var output = "";

    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }

    output += String.fromCharCode(codePoint);
    return output;
}


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanPlayerName; });
function cleanPlayerName(name,joinChar,capitalize){name=name.replace(/'/g,'').replace(/\./g,'').replace(/'/g,"''").replace(/¡/g,'i').replace(/¢/g,'').replace(/£/g,'').replace(/¤/g,'').replace(/¥/g,'').replace(/¦/g,'').replace(/§/g,'').replace(/¨/g,'').replace(/©/g,'').replace(/ª/g,'').replace(/«/g,'').replace(/¬/g,'').replace(/­/g,'').replace(/¯/g,'').replace(/°/g,'').replace(/²/g,'').replace(/³/g,'').replace(/´/g,'').replace(/µ/g,'').replace(/¶/g,'').replace(/·/g,'').replace(/¸/g,'').replace(/¹/g,'').replace(/º/g,'').replace(/»/g,'').replace(/¼/g,'').replace(/½/g,'').replace(/¾/g,'').replace(/¿/g,'').replace(/À/g,'a').replace(/Á/g,'a').replace(/Â/g,'a').replace(/Ã/g,'a').replace(/Ä/g,'a').replace(/Ã¹/g,'ù').replace(/Å/g,'a').replace(/Æ/g,'a').replace(/Ç/g,'c').replace(/È/g,'e').replace(/É/g,'e').replace(/Ê/g,'e').replace(/Ë/g,'e').replace(/Ì/g,'i').replace(/Í/g,'i').replace(/Î/g,'i').replace(/Ï/g,'i').replace(/Ð/g,'d').replace(/Ñ/g,'n').replace(/Ò/g,'o').replace(/Ó/g,'o').replace(/Ô/g,'o').replace(/Õ/g,'o').replace(/Ö/g,'o').replace(/×/g,'x').replace(/Ø/g,'0').replace(/Ù/g,'u').replace(/Ú/g,'u').replace(/Û/g,'u').replace(/Ü/g,'u').replace(/Ý/g,'y').replace(/Þ/g,'p').replace(/ß/g,'b').replace(/à/g,'a').replace(/á/g,'a').replace(/â/g,'a').replace(/ã/g,'a').replace(/ä/g,'a').replace(/å/g,'a').replace(/æ/g,'a').replace(/ç/g,'c').replace(/è/g,'e').replace(/é/g,'e').replace(/ê/g,'e').replace(/ë/g,'e').replace(/ì/g,'i').replace(/í/g,'i').replace(/î/g,'i').replace(/ï/g,'i').replace(/ð/g,'o').replace(/ñ/g,'n').replace(/ò/g,'o').replace(/ó/g,'o').replace(/ô/g,'o').replace(/õ/g,'o').replace(/ö/g,'o').replace(/÷/g,'').replace(/ø/g,'o').replace(/ù/g,'u').replace(/ú/g,'u').replace(/û/g,'u').replace(/ü/g,'u').replace(/ý/g,'y').replace(/þ/g,'b').replace(/ÿ/g,'y').split(' ').join(joinChar);if(capitalize){return name;}return name.toLowerCase();}

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return imageMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return teamCLMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_entities__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_IconFont__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_cleanString__ = __webpack_require__(264);
'use-strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var teamsURL=__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getFootballTeams('min');var playersURL=__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getFootballPlayers();var countriesUrl=__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getCountriesFlag();var positionMarker=__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getWidgetPositionMarker();var competitionId=void 0;var gazzanetWidget=void 0;var imageMap={5861:1,4911:1,1:1,2761:2,1781:2,37:2,33:2,7061:2,7051:2,2:2,14:3,3:3,17:4,6901:4,4821:4,4301:4,24:4,8351:4,8561:4,4:4,7691:5,21:5,8121:5,29:5,36:5,6311:5,5011:5,161:5,4971:5,6881:5,7931:5,3961:5,7121:5,3821:5,7941:5,5:5,4011:331,331:331,4791:6,8551:6,8581:6,6:6,6861:22,39:22,4941:22,104:22,8201:22,4351:22,8211:22,5001:22,7521:22,8191:22,79:22,162:22,4141:22,22:22,7081:20,52:20,53:20,5511:20,2741:20,2911:20,6281:20,2961:20,8171:20,2751:20,8181:20,103:20,8471:20,20:20,101:19,19:19,5641:501,501:501,46:15,15:15,18:8,6481:8,8111:8,28:8,30:8,8:8,8571:8,102:61,61:61,5841:5841,11:11,7:7,5691:5691,8281:8281,9181:9181};var teamCLMap={127:'Inter',178:'Barcellona',156:'Bayern',128:'Juventus',43:'Man. City',149:'PSG',14:'Liverpool',8:'Chelsea',1341:'Zenit',186:'Real Madrid',175:'Atl. Madrid',157:'Borussia',459:'Napoli',455:'Shakhtar',6:'Tottenham',215:'Ajax',251:'Benfica',143:'Lione',164:'Leverkusen',857:'Salisburgo',202:'Olympiacos',413:'Club Brugge',191:'Valencia',394:'Zagabria D.',271:'Mosca',414:'Genk',208:'Galatasaray',6339:'Lipsia',273:'Slavia Praga',214:'Stella Rossa',456:'Atalanta',429:'Lille',371:'Vitória SC',5666:'Wolfsberg',67:'Rangers',4169:'Krasnodar',204:'PSV',1963:'Young Boys',198:'Feyenoord',227:'Ferencváros',129:'Lazio',1:'Man. United',5997:'Olexandria',179:'Siviglia',383:'Trabzonspor',255:'Sporting CP',194:'Dinamo Kiev',280:'LASK',61:'Celtic',313:'AZ Alkmaar',3751:'Astana',172:'Wolfsburg',3107:'FK Qarabag',201:'Porto',177:'Espanyol',678:'Gent',2628:'CFR Cluj',150:'Rennes',152:'St. Étienne',993:'Malmo',373:'Std Liegi',121:'Roma',6128:'Ludogorets',481:'Basilea',2161:'Dudelange',683:'Borussia',378:'Besiktas',2133:'Istanbul',935:'Lugano',159:'Francoforte',197:'Rosenborg',479:'APOEL',39:'Wolverhampton',3:'Arsenal',569:'Copenaghen',1450:'Getafe',211:'S. Bratislava',216:'P. Belgrado',372:'Braga',1340:'CSKA Mosca',367:'R. Ceca',537:'Bosnia-Erz.',504:'N. Macedonia',117:'Irl. del Nord',3907:'FC Progrès',916:'TNS',1490:'Shamrock',3758:'FC Kaisar',2830:'Buducnost',12975:'Ararat A.',8858:'Lincoln',1788:'Lok. Plovdiv',474:'Olimpija',2856:'Zrinjski',2768:'Connah\'s Q.',1406:'Djurgårdens',4089:'Sfintul G.',3012:'H. Beer Sheva',1016:'Lok Tbilisi',1003:'Apollon',13197:'FC Kolos',2842:'Borac BL',4950:'Hartberg',2959:'Dunajská S.',265:'Steaua Buc.',2046:'Honvéd',2107:'R. Ceca U21'};var reusableCols={title:{colName:'title',// eslint-disable-next-line
label:function label(colName){var titleLabels={'Round of 32':'Sedicesimi di finale','Round of 16':'Ottavi di finale','Quarter-Finals':'Quarti di finale','Semi-Finals':'Semifinali',Round:'GIORNATA 1','Play-Offs':'GIORNATA 2','3rd and 4th Place':'Finale per il 3° posto',Final:'Finale',A:'GRUPPO A',B:'GRUPPO B',C:'GRUPPO C',D:'GRUPPO D',E:'GRUPPO E',F:'GRUPPO F',G:'GRUPPO G',H:'GRUPPO H',I:'GRUPPO I',J:'GRUPPO J',K:'GRUPPO K',L:'GRUPPO L'};return titleLabels[colName];},width:22,position:'absolute',left:'1.2%',top:'2px',caps:'uppercase',alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){return this[colName];},notNormalize:true,order:0,hideTooltip:true}};var tableConfigurationSet={competitionTeams:{title:{colName:'title',// eslint-disable-next-line
label:function label(){return'Squadra';},width:34,position:'absolute',left:'30px',alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){return this[colName];},notNormalize:true,order:0,hideTooltip:true},teamName:{colName:'teamName',label:function label(colName){return this[colName];},width:28,alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){//return this[colName];
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{label:this[colName],path:__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].prettyTeamUrl(1,competitionId,"corriere",this[colName]),hideArrow:true});},order:0,hideTooltip:true},teamId:{colName:'teamId',label:function label(colName){return this[colName];},width:13,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{image:''+teamsURL+this.teamId+'.png'});},order:0,notNormalize:true,hideTooltip:true},form:{colName:'form',label:function label(colName){return this[colName];},width:18,sortingValue:function sortingValue(form){return(form.match(/W/g)||[]).length;},rowLabel:function rowLabel(colName){var formLabel={W:{label:'V',color:'green'},L:{label:'P',color:'whiteRed'},D:{label:'N',color:'lighterGray'}};var form=this[colName];if(form.length>5){form=form.slice(-5);}return form&&form.reverse().map(function(res,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{color:formLabel[res.label].color,label:formLabel[res.label].label,isForm:true,key:index,weight:'bold',path:'#'+res.match.homeTeam.teamName+'-'+res.match.awayTeam.teamName,hideArrow:true,isTitleNarrowMedium:true});});},order:0,hideTooltip:true},startingPosition:{colName:'startingPosition',label:function label(colName){return this[colName];},width:5,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){if(this.position-this.startingPosition<0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-up-triangle',color:'green',font:12});}else if(this.position-this.startingPosition>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-up-triangle',color:'red',font:12,rotate:90});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-equal',font:12});},order:0,hideTooltip:true},joinCols:{colName:'leftCol:rightCol',width:10,label:function label(colName){var colsName=colName.split(':');return this[colsName[0]]+':'+this[colsName[1]];},rowLabel:function rowLabel(colName){var colsName=colName.split(':');return this[colsName[0]]+':'+this[colsName[1]];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},points:{colName:'points',width:5,weight:'bold',size:1,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},position:{colName:'position',width:5,label:function label(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:'none',color:'black'});},rowLabel:function rowLabel(colName){var qualification=this.qualification;return qualification&&qualification.qualify?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:positionMarker&&positionMarker[qualification.qualify]&&positionMarker[qualification.qualify][qualification.method]?positionMarker[qualification.qualify][qualification.method]:'',label:this[colName],color:'black'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:'none',label:this[colName],color:'black'});},sortingValue:function sortingValue(value){return value;},order:0,notNormalize:true,hideTooltip:true},defaultCols:{colName:'default',width:5,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,joinDirection:'',hideTooltip:true}},competitionMarkers:{title:{colName:'title',// eslint-disable-next-line
label:function label(){return'Giocatore';},width:34,position:'absolute',left:'3%',alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){return this[colName];},notNormalize:true,order:0,hideTooltip:true},position:{colName:'position',width:1,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,joinDirection:'',hideTooltip:true},teamName:{colName:'teamName',label:function label(colName){return this[colName];},width:25,alignment:'flex-start',overrideMargin:'0',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){//return this[colName];
if(competitionId===21){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{label:this[colName],path:__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].prettyTeamUrl(1,competitionId,"corriere",this[colName]),hideArrow:true});}else{return this[colName];}},order:0,hideTooltip:true},teamId:{colName:'teamId',label:function label(colName){return this[colName];},width:5,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{image:''+teamsURL+this.teamId+'.png'});},order:0,hideTooltip:true},playerId:{colName:'playerId',label:function label(colName){return this[colName];},width:7,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){var formattedDate=this.playerBirthDate?this.playerBirthDate.split('-').reverse().join(''):'';var firstName=this.playerFirstName?this.playerFirstName.toLowerCase():'';var lastName=this.playerSecondName?this.playerSecondName.toLowerCase():'';var formattedPlayer=firstName&&lastName?firstName+'_'+lastName:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{isPlayer:true,image:''+playersURL+Object(__WEBPACK_IMPORTED_MODULE_7__utils_cleanString__["a" /* cleanPlayerName */])(formattedPlayer,'_')+'_'+formattedDate+'.png'});},order:0,hideTooltip:true},playerName:{colName:'playerName',label:function label(colName){return this[colName];},width:25,alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){var gazzanetName=this.playerName;var _gazzanetName$split=gazzanetName.split(' '),_gazzanetName$split2=_slicedToArray(_gazzanetName$split,2),name=_gazzanetName$split2[0],surname=_gazzanetName$split2[1];var returnedName=surname;if(!surname){returnedName=name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{label:gazzanetWidget?__WEBPACK_IMPORTED_MODULE_1_entities___default.a.decodeHTML(returnedName):__WEBPACK_IMPORTED_MODULE_1_entities___default.a.decodeHTML(this[colName]),path:__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getPlayerUrl(__WEBPACK_IMPORTED_MODULE_1_entities___default.a.decodeHTML(this[colName]),this.playerId,1,"corriere"),hideArrow:true,margin:gazzanetWidget?'0 5px':'0px'});},order:0,hideTooltip:true},playerCountry:{colName:'playerCountry',label:function label(colName){return this[colName];},width:5,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{image:''+countriesUrl+this.playerCountry+'.jpg',isFlag:true});},order:0,hideTooltip:true},playerRole:{colName:'playerRole',width:15,alignment:'left',overridePadding:'0px 0px 0px 15px',size:0.85,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},goals:{colName:'goals',width:6,weight:'bold',size:0.85,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},defaultCols:{colName:'default',width:6,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,joinDirection:'',hideTooltip:true}},rugbyStandings:{title:{colName:'title',// eslint-disable-next-line
label:function label(){return'Squadra';},width:34,position:'absolute',left:'30px',alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){return this[colName];},notNormalize:true,order:0,hideTooltip:true},teamName:{colName:'teamName',label:function label(colName){return this[colName];},width:28,alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){//return this[colName];
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{label:this[colName],path:__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].prettyTeamUrl(1,competitionId,"corriere",this[colName]),hideArrow:true});},order:0,hideTooltip:true},teamId:{colName:'teamId',label:function label(colName){return this[colName];},width:13,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{image:''+__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getRugbyTeams('min')+this.teamId+'.png'});},order:0,notNormalize:true,hideTooltip:true},joinCols:{colName:'leftCol:rightCol',width:10,label:function label(colName){var colsName=colName.split(':');return this[colsName[0]]+':'+this[colsName[1]];},rowLabel:function rowLabel(colName){var colsName=colName.split(':');return this[colsName[0]]+':'+this[colsName[1]];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},points:{colName:'points',width:5,weight:'bold',size:1,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},position:{colName:'position',width:5,label:function label(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:'none',color:'black'});},rowLabel:function rowLabel(colName){var qualification=this.qualification;return qualification&&qualification.qualify?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:positionMarker[qualification.qualify][qualification.method],label:this[colName],color:'black'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:'none',label:this[colName],color:'black'});},sortingValue:function sortingValue(value){return value;},order:0,notNormalize:true,hideTooltip:true},defaultCols:{colName:'default',width:5,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,joinDirection:'',hideTooltip:true}}};var tableConfigurationSetMobile={competitionTeams:{title:{colName:'title',// eslint-disable-next-line
label:function label(){return'Squadra';},width:34,position:'absolute',left:'1.2%',alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){return this[colName];},notNormalize:true,order:0,hideTooltip:true},teamName:{colName:'teamName',label:function label(colName){return this[colName];},width:28,alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){//return this[colName];
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{label:this[colName],path:__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].prettyTeamUrl(1,competitionId,"corriere",this[colName]),hideArrow:true});},order:0,hideTooltip:true},teamId:{colName:'teamId',label:function label(colName){return this[colName];},width:13,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{image:''+teamsURL+this.teamId+'.png'});},order:0,notNormalize:true,hideTooltip:true},form:{colName:'form',label:function label(colName){return this[colName];},width:18,sortingValue:function sortingValue(form){return(form.match(/W/g)||[]).length;},rowLabel:function rowLabel(colName){var formLabel={W:{label:'V',color:'green'},L:{label:'P',color:'whiteRed'},D:{label:'N',color:'lighterGray'}};var form=this[colName];if(form.length>5){form=form.slice(-5);}return form&&form.reverse().map(function(res,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{color:formLabel[res.label].color,label:formLabel[res.label].label,isForm:true,key:index,weight:'bold',path:'#'+res.match.homeTeam.teamName+'-'+res.match.awayTeam.teamName,hideArrow:true,isTitleNarrowMedium:true});});},order:0,hideTooltip:true},startingPosition:{colName:'startingPosition',label:function label(colName){return this[colName];},width:5,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){if(this.position-this.startingPosition<0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-up-triangle',color:'green',font:12});}else if(this.position-this.startingPosition>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-up-triangle',color:'red',font:12,rotate:90});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_shared_IconFont__["a" /* default */],{className:'icon-matchcenter-equal',font:12});},order:0,hideTooltip:true},joinCols:{colName:'leftCol:rightCol',width:10,label:function label(colName){var colsName=colName.split(':');return this[colsName[0]]+':'+this[colsName[1]];},rowLabel:function rowLabel(colName){var colsName=colName.split(':');return this[colsName[0]]+':'+this[colsName[1]];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},points:{colName:'points',width:5,weight:'bold',size:1,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},position:{colName:'position',width:5,label:function label(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:'none',color:'black'});},rowLabel:function rowLabel(colName){var qualification=this.qualification;return qualification&&qualification.qualify?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:positionMarker&&positionMarker[qualification.qualify]&&positionMarker[qualification.qualify][qualification.method]?positionMarker[qualification.qualify][qualification.method]:'',label:this[colName],color:'black'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_shared_PositionMarker__["a" /* default */],{bgColor:'none',label:this[colName],color:'black'});},sortingValue:function sortingValue(value){return value;},order:0,notNormalize:true,hideTooltip:true},defaultCols:{colName:'default',width:5,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,joinDirection:'',hideTooltip:true}},competitionMarkers:{title:{colName:'title',// eslint-disable-next-line
label:function label(){return'Giocatore';},width:34,position:'absolute',left:'1.2%',alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){return this[colName];},notNormalize:true,order:0,hideTooltip:true},position:{colName:'position',width:2,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,joinDirection:'',hideTooltip:true},teamName:{colName:'teamName',label:function label(colName){return this[colName];},width:24,alignment:'flex-start',overrideMargin:'0',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){//return this[colName];
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{label:this[colName],path:__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].prettyTeamUrl(1,competitionId,"corriere",this[colName]),hideArrow:true});},order:0,hideTooltip:true},teamId:{colName:'teamId',label:function label(colName){return this[colName];},width:5,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{image:''+teamsURL+this.teamId+'.png'});},order:0,hideTooltip:true},playerId:{colName:'playerId',label:function label(colName){return this[colName];},width:7,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){var formattedDate=this.playerBirthDate?this.playerBirthDate.split('-').reverse().join(''):'';var firstName=this.playerFirstName?__WEBPACK_IMPORTED_MODULE_1_entities___default.a.decodeHTML(this.playerFirstName.toLowerCase()):'';var lastName=this.playerSecondName?__WEBPACK_IMPORTED_MODULE_1_entities___default.a.decodeHTML(this.playerSecondName.toLowerCase()):'';var formattedPlayer=firstName&&lastName?firstName+'_'+lastName:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{isPlayer:true,image:''+playersURL+Object(__WEBPACK_IMPORTED_MODULE_7__utils_cleanString__["a" /* cleanPlayerName */])(formattedPlayer,'_')+'_'+formattedDate+'.png'});},order:0,hideTooltip:true},playerName:{colName:'playerName',label:function label(colName){return this[colName];},width:24,alignment:'flex-start',sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(colName){var gazzanetName=this.playerName;var _gazzanetName$split3=gazzanetName.split(' '),_gazzanetName$split4=_slicedToArray(_gazzanetName$split3,2),name=_gazzanetName$split4[0],surname=_gazzanetName$split4[1];var returnedName=surname;if(!surname){returnedName=name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_LabelLink__["a" /* default */],{label:gazzanetWidget?__WEBPACK_IMPORTED_MODULE_1_entities___default.a.decodeHTML(returnedName):__WEBPACK_IMPORTED_MODULE_1_entities___default.a.decodeHTML(this[colName]),path:__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getPlayerUrl(__WEBPACK_IMPORTED_MODULE_1_entities___default.a.decodeHTML(this[colName]),this.playerId,1,"corriere"),hideArrow:true,margin:gazzanetWidget?'0 5px':'0px'});},order:0,hideTooltip:true},playerCountry:{colName:'playerCountry',label:function label(colName){return this[colName];},width:5,sortingValue:function sortingValue(teamName){return teamName;},rowLabel:function rowLabel(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_shared_TeamLabel__["a" /* default */],{image:''+countriesUrl+this.playerCountry+'.jpg',isFlag:true});},order:0,hideTooltip:true},playerRole:{colName:'playerRole',width:15,alignment:'left',overridePadding:'0px 0px 0px 15px',size:0.85,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},goals:{colName:'goals',width:6,weight:'bold',size:0.85,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,hideTooltip:true},defaultCols:{colName:'default',width:6,label:function label(colName){return this[colName];},rowLabel:function rowLabel(colName){return this[colName];},sortingValue:function sortingValue(value){return value;},order:0,joinDirection:'',hideTooltip:true}}};var TableConfiguration=function(){function TableConfiguration(tableName,isMobile,competitionIdPass,isGazzanet){var _this=this;_classCallCheck(this,TableConfiguration);this.substituteJoinedCols=function(colsConfiguration){var _loop=function _loop(joinedCol){var onlyJoinCols=colsConfiguration.filter(function(col){return col.joinDirection==='left'&&col.colName===joinedCol.leftCol||col.joinDirection==='right'&&col.colName===joinedCol.rightCol;});var colJoin=Object.assign({},_this.colsArray.joinCols);var leftCol=onlyJoinCols.filter(function(col){return col.joinDirection==='left';})[0];var rightCol=onlyJoinCols.filter(function(col){return col.joinDirection==='right';})[0];colJoin.colName=leftCol.colName+':'+rightCol.colName;colJoin.order=Math.min(leftCol.order,rightCol.order);colsConfiguration.push(colJoin);};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=_this.joinedCols[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var joinedCol=_step.value;_loop(joinedCol);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return colsConfiguration.filter(function(col){return col.joinDirection!=='left'&&col.joinDirection!=='right';});};this.normalizeColsWidth=function(colsConfiguration){var sum=colsConfiguration.reduce(function(counter,a){if(!a.notNormalize){counter+=a.width;}return counter;},0);if(sum<100){var increaseValue=Math.ceil((100-sum)/colsConfiguration.length);var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=colsConfiguration[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var col=_step2.value;if(!col.notNormalize){col.width+=increaseValue;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}return colsConfiguration;};this.normalizeColsWidthWithTitle=function(colsConfiguration){var sum=colsConfiguration.reduce(function(counter,a){if(!a.notNormalize){counter+=a.width;}return counter;},0);if(sum<100){var increaseValue=Math.ceil((100-sum)/(colsConfiguration.length-1));var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=colsConfiguration[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var col=_step3.value;if(!col.notNormalize){col.width+=increaseValue;}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}return colsConfiguration;};this.createDefaultCol=function(colName){var colDef=Object.assign({},_this.colsArray.defaultCols);colDef.colName=colName;colDef.order=_this.orderCols[colName];if(_this.isJoinedLeftCols(colName)){colDef.joinDirection='left';_this.hasJoin=true;}else if(_this.isJoinedRightCols(colName)){colDef.joinDirection='right';_this.hasJoin=true;}return colDef;};this.createCustomCol=function(colName){var isHeader=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var col=Object.assign({},_this.colsArray[colName]);col.order=_this.orderCols[colName];if(isHeader&&col.hasOwnProperty('alignmentHeader')){col.alignment=col.alignmentHeader;}return col;};this.currentTable=tableName;this.colsArray=tableConfigurationSet[tableName];this.orderCols=__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getWidgetColsOrder(tableName);var joinedCols=__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getWidgetJoinedCols(tableName);if(!Array.isArray(joinedCols)){joinedCols=[joinedCols];}this.joinedCols=joinedCols;this.isMobile=isMobile;competitionId=Number(competitionIdPass);gazzanetWidget=isGazzanet;this.colsArray=!this.isMobile?tableConfigurationSet[tableName]:tableConfigurationSetMobile[tableName];this.skipCols=!isMobile?__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getWidgetSkipCols(tableName).colName:__WEBPACK_IMPORTED_MODULE_2__common_configManager_configManager__["a" /* default */].getWidgetSkipCols(tableName).isMobile;this.hasJoin=false;}_createClass(TableConfiguration,[{key:'isJoinedLeftCols',value:function isJoinedLeftCols(colName){if(this.joinedCols){var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=this.joinedCols[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var col=_step4.value;if(col.leftCol===colName){return true;}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}return false;}},{key:'isJoinedRightCols',value:function isJoinedRightCols(colName){if(this.joinedCols){var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=this.joinedCols[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var col=_step5.value;if(col.rightCol===colName){return true;}}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}return false;}},{key:'isInSkipCols',value:function isInSkipCols(value){return this.skipCols.indexOf(value);}},{key:'createColumnsConfiguration',value:function createColumnsConfiguration(colsArray){switch(this.currentTable){case'competitionRoundMatches':return this.normalizeColsWidth(this.colsArray);default:return this.addOthersCols(colsArray);}}},{key:'createColumnsConfigurationWithTitle',value:function createColumnsConfigurationWithTitle(colsArray,title){switch(this.currentTable){case'competitionRoundMatches':return this.addTitle(!this.isMobile?tableConfigurationSet.competitionRoundMatchesHeader:tableConfigurationSetMobile.competitionRoundMatchesHeader,title);default:return this.addOthersColsWithTitle(colsArray,title);}}},{key:'addOthersCols',value:function addOthersCols(colsArray){var colsConfiguration=[];var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=colsArray[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var colName=_step6.value;if(this.isInSkipCols(colName)>=0){//eslint-disable-next-line
continue;}if(this.colsArray.hasOwnProperty(colName)){colsConfiguration.push(this.createCustomCol(colName));}else{colsConfiguration.push(this.createDefaultCol(colName));}}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}if(this.hasJoin){colsConfiguration=this.substituteJoinedCols(colsConfiguration);this.hasJoin=false;}colsConfiguration=this.normalizeColsWidth(colsConfiguration);return colsConfiguration.sort(function(colA,colB){return colA.order-colB.order;});}// Only for table header
},{key:'addOthersColsWithTitle',value:function addOthersColsWithTitle(colsArray,title){var colsConfiguration=[];//let hasJoin = false;
var colTitle=Object.assign({},this.colsArray.title);colTitle.colName=title;colTitle.order=this.orderCols.title;colsConfiguration.push(colTitle);var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=colsArray[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var colName=_step7.value;if(this.isInSkipCols(colName)>=0){//eslint-disable-next-line
continue;}if(this.colsArray.hasOwnProperty(colName)){colsConfiguration.push(this.createCustomCol(colName,true));}else{colsConfiguration.push(this.createDefaultCol(colName));}}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}if(this.hasJoin){colsConfiguration=this.substituteJoinedCols(colsConfiguration);this.hasJoin=false;}colsConfiguration=this.normalizeColsWidthWithTitle(colsConfiguration);return colsConfiguration.sort(function(colA,colB){return colA.order-colB.order;});}},{key:'addTitle',value:function addTitle(colsArray,title){var colsConfiguration=[];var colTitle=Object.assign({},reusableCols.title);colTitle.colName=title;colTitle.order=this.orderCols.title;colsConfiguration.push(colTitle);return colsConfiguration.concat(colsArray);}}]);return TableConfiguration;}();/* harmony default export */ __webpack_exports__["a"] = (TableConfiguration);

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(271);
var PositionMarker=function PositionMarker(_ref){var color=_ref.color,size=_ref.size,bgColor=_ref.bgColor,label=_ref.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* PositionWrapper */],{bgColor:bgColor,color:color,size:size},label);};PositionMarker.propTypes={color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,bgColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (PositionMarker);

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PositionWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: ',';\n  line-height: 2;\n  background: ',';\n  height: 2em;\n  width: 1.5em;\n  text-align: center;\n'],['\n  font-size: ',';\n  line-height: 2;\n  background: ',';\n  height: 2em;\n  width: 1.5em;\n  text-align: center;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PositionWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.size?props.size+'em':'1em';},function(props){return props.bgColor?props.theme.colors[props.bgColor]:'transparent';});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_grid_system__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_grid_system___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_Label__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tableConfiguration_tableConfiguration__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_rcs_gaz_mc_core_FE__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_rcs_gaz_mc_core_FE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_rcs_gaz_mc_core_FE__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import * as status from '../../constants';
var imagesURL='https://images2.gazzettaobjects.it/assets-mc/calcio/squadre/min/';var MatchRowBoxed=function(_Component){_inherits(MatchRowBoxed,_Component);function MatchRowBoxed(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MatchRowBoxed);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MatchRowBoxed.__proto__||Object.getPrototypeOf(MatchRowBoxed)).call.apply(_ref,[this].concat(args))),_this),_this.getGazzanetDomain=function(url){var returnedDomain='gazzetta';if(url&&url.hostname){var site=url.hostname;var _site$split=site.split('.'),_site$split2=_slicedToArray(_site$split,2),domain=_site$split2[1];returnedDomain=domain;}return returnedDomain;},_this.homeResPen=function(){var matchRow=_this.props.matchRow;var homeScore=matchRow.getIn(['homeTeam','score']);var homeResPen=matchRow.getIn(['homeTeam','starData','shootOuts','score'])?matchRow.getIn(['homeTeam','starData','shootOuts','score']):0;return homeScore+homeResPen;},_this.awayResPen=function(){var matchRow=_this.props.matchRow;var awayScore=matchRow.getIn(['awayTeam','score']);var awayResPen=matchRow.getIn(['awayTeam','starData','shootOuts','score'])?matchRow.getIn(['awayTeam','starData','shootOuts','score']):0;return awayScore+awayResPen;},_this.formatDate=function(date){var options={weekday:'long',hour:'2-digit',minute:'2-digit'};return new Date(date).toLocaleString('it-IT',options);},_this.formatDatePosticipated=function(date,days,status){var options_only_date={day:'2-digit',month:'2-digit',year:'2-digit'};var options_weekday_plus_time={weekday:'long',hour:'2-digit',minute:'2-digit'};var options_date_plus_time={day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'};var nowDate=Math.round(new Date().getTime()/1000);var datePosticipe=Math.round(new Date(date).getTime()/1000);var calculateDatemore6=Math.round(nowDate+60*60*24*days);if(calculateDatemore6>=datePosticipe){return new Date(date).toLocaleString('it-IT',options_weekday_plus_time);}else{if(status==='POSTPONED')return'RINV '+new Date(date).toLocaleString('it-IT',options_only_date);return''+new Date(date).toLocaleString('it-IT',options_date_plus_time);}},_this.formatFullDate=function(date){var options={weekday:'long',day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'};return new Date(date).toLocaleString('it-IT',options);},_this.isGazzanet=function(){var disableLink=true;if(false){if(window.location&&window.location.hostname){var site=window.location.hostname;switch(site){case'www.fcinter1908.it':case'www.forzaroma.info':case'www.calcionapoli1926.it':case'dev.fcinter1908.it':case'dev.forzaroma.info':case'dev.calcionapoli1926.it':disableLink=false;break;default:disableLink=true;break;}}else{disableLink=true;}}else{disableLink=false;}return disableLink;},_this.renderCircle=function(group){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* GroupCircle */],{className:'secondBackground'},'Gir. ',group||'');},_temp),_possibleConstructorReturn(_this,_ret);}/*const isHomeWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) > Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  const isAwayWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) < Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';*///const isLive = () => matchRow.get('status') === 'LIVE';
/*const awayResPen = (matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
  const homeResPen = (matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;*/_createClass(MatchRowBoxed,[{key:'render',value:function render(){var _props=this.props,matchRow=_props.matchRow,isMobile=_props.isMobile,isHighlight=_props.isHighlight,sportId=_props.sportId,competitionId=_props.competitionId,dictionary=_props.dictionary,isCup=_props.isCup,trackString=_props.trackString;var prettyMatchUrlVal=matchRow?Object(__WEBPACK_IMPORTED_MODULE_7__common_rcs_gaz_mc_core_FE__["prettyMatchUrl"])(matchRow.getIn(['homeTeam','teamName']),matchRow.getIn(['awayTeam','teamName']),matchRow.get('matchId'),sportId,competitionId,this.getGazzanetDomain(window.location)):'';var teamShortHome=matchRow?matchRow.getIn(['homeTeam','teamName']):'sq1';var teamShortAway=matchRow?matchRow.getIn(['awayTeam','teamName']):'sq2';var newTeamHomeID=matchRow&&matchRow.getIn(['homeTeam','teamId']);var newTeamAwayID=matchRow&&matchRow.getIn(['awayTeam','teamId']);if(String(competitionId)==='6'||String(competitionId)==='3'||String(competitionId)==='5'&&!isMobile){teamShortHome=__WEBPACK_IMPORTED_MODULE_6__utils_tableConfiguration_tableConfiguration__["c" /* teamCLMap */][newTeamHomeID]||teamShortHome;teamShortAway=__WEBPACK_IMPORTED_MODULE_6__utils_tableConfiguration_tableConfiguration__["c" /* teamCLMap */][newTeamAwayID]||teamShortAway;}if(String(competitionId)==='941'||String(competitionId)==='4'||String(competitionId)==='352'){teamShortHome=__WEBPACK_IMPORTED_MODULE_6__utils_tableConfiguration_tableConfiguration__["c" /* teamCLMap */][newTeamHomeID]||teamShortHome;teamShortAway=__WEBPACK_IMPORTED_MODULE_6__utils_tableConfiguration_tableConfiguration__["c" /* teamCLMap */][newTeamAwayID]||teamShortAway;}var currentMatch=this.props.matchRow&&this.props.matchRow.toJS();var matchDate=currentMatch&&this.formatFullDate(currentMatch.date);var matchend=currentMatch&&currentMatch.status==='FULL'&&currentMatch.finalMatchDateTime?this.formatFullDate(currentMatch.finalMatchDateTime):'';if(!matchRow||matchRow===undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* MatchLinkWrapper */],{href:'',className:'resetLink',disableLink:this.isGazzanet()?'disableLink':'','data-matchdate':undefined,'data-matchid':undefined,'data-matchend':undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* MatchRowWrapper */],{isHighlight:isHighlight,isGazzanet:this.isGazzanet(),isMobile:isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* MatchRowWrapperInt */],{isMobile:isMobile,isCup:isCup,isGazzanet:"corriere"==='gazzanet'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter has-background-primary preMainColorBackground',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,weight:'bold'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{font:'narrowBold',label:'STATUS',size:isMobile?0.75:0.8,color: false?'white':'black',isCapitalize:true,margin:isCup&&isMobile?'2px 12px 2px 0':'2px 0px'})),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* MatchRowDataContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentStart',md:12,sm:12,xs:12,style:{paddingLeft:'5%',paddingRight:'5%',height:'34px',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */]//label={matchRow.getIn(['homeTeam', 'teamName'])}
,{label:teamShortHome,className:'firstRow',color:'black',image:'sq1.png',marginLeft:0.5,font:'narrowRegular',size:14,isCorriereCalendar:true,whiteSpace: false?'normal':''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:'0',font:'narrowBold',margin:isCup?'0px 7px':'0px 0 0 10px',size:1.1,className:'realTimeScore'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentStart',md:12,sm:12,xs:12,style:{paddingLeft:'5%',paddingRight:'5%',height:'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{label:'sq2',color:'black',image:'undefined.png',marginLeft:0.5,font:'narrowRegular',size:14,isCorriereCalendar:true,whiteSpace: false?'normal':''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:'0',font:'narrowBold',margin:isCup?'0px 7px':'0px 0 0 10px',size:1.1,className:'realTimeScore'}))),isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* MatchRowDataContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,height:isMobile?'34px':'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{color:'black',image:'shield.png',marginLeft:0.5,font:'narrowRegular',size:15,isCorriereCalendar:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:'0',font:'narrowBold',margin:'0px 2px 0px 6px',size:1.1})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,height:isMobile?'20px':'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{label:'sq2',color:'black',font:'narrowRegular',size:15,isCorriereCalendar:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,height:isMobile?'34px':'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{color:'black',image:'shield.png',marginLeft:0.5,font:'narrowRegular',size:15,isCorriereCalendar:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:0,font:'narrowBold',margin:'0px 2px 0px 6px',size:1.1})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,height:isMobile?'20px':'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{label:teamShortAway,color:'black',font:'narrowRegular',size:15,isCorriereCalendar:true}))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* MatchLinkWrapper */],{href:''+prettyMatchUrlVal+(trackString||''),className:'resetLink',disableLink:this.isGazzanet()?'disableLink':'','data-matchdate':matchDate,'data-matchid':matchRow.get('matchId'),'data-matchend':matchend},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* MatchRowWrapper */],{isHighlight:isHighlight,isGazzanet:this.isGazzanet(),isMobile:isMobile//href={`/test/matchcenter/Calcio/${dictionary.competitionTable.competitionLink[(competitionId)]}/partite/${matchRow.getIn(['homeTeam', 'teamName'])}-${matchRow.getIn(['awayTeam', 'teamName'])}/${matchRow.get('matchId')}/`}
},isCup&&matchRow.get('group')&&matchRow.get('group')!=='undefined'&&this.renderCircle(matchRow.get('group')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* MatchRowWrapperInt */],{isMobile:isMobile,isCup:isCup,isGazzanet:"corriere"==='gazzanet'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter has-background-primary '+(matchRow.get('status')==='LIVE'?'LiveMainColorBackground':'preMainColorBackground'),md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,weight:'bold'}},matchRow.get('status')==='PREMATCH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{font:'narrowBold',label:this.formatDatePosticipated(matchRow.get('date'),6),size:isMobile?0.75:0.8,color: false?'white':'black',isCapitalize:true,margin:isCup&&isMobile?'2px 12px 2px 0':'2px 0px'}),matchRow.get('status')==='LIVE'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{font:'narrowBold',label:dictionary.timing.header[matchRow.getIn(['timing','tag'])],size:isMobile?0.75:0.8,color:'white',isCapitalize:true,margin:isCup&&isMobile?'2px 12px 2px 0':'2px 0px'}),matchRow.get('status')==='FULL'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{font:'narrowBold',label:'FINE',size:isMobile?0.75:0.8,color: false?'white':'black',isCapitalize:true,margin:isCup&&isMobile?'2px 12px 2px 0':'2px 0px'}),matchRow.get('status')==='POSTPONED'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{font:'narrowBold',label:'RINVIATA',size:isMobile?0.75:0.8,color: false?'white':'black',isCapitalize:true,margin:isCup&&isMobile?'2px 12px 2px 0':'2px 0px'}),matchRow.get('status')==='DELAYED'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{font:'narrowBold',label:'RITARDATO',size:isMobile?0.75:0.8,color: false?'white':'black',isCapitalize:true,margin:isCup&&isMobile?'2px 12px 2px 0':'2px 0px'}),matchRow.get('status')==='ABANDONED'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{font:'narrowBold',label:'ABBANDONATO',size:isMobile?0.75:0.8,color: false?'white':'black',isCapitalize:true,margin:isCup&&isMobile?'2px 12px 2px 0':'2px 0px'}),matchRow.get('status')==='SUSPENDED'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{font:'narrowBold',label:'SOSPESO',size:isMobile?0.75:0.8,color: false?'white':'black',isCapitalize:true,margin:isCup&&isMobile?'2px 12px 2px 0':'2px 0px'})),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* MatchRowDataContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentStart',md:12,sm:12,xs:12,style:{paddingLeft:'5%',paddingRight:'5%',height:'34px',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */]//label={matchRow.getIn(['homeTeam', 'teamName'])}
,{label:teamShortHome,className:'firstRow',color:'black',image:''+imagesURL+matchRow.getIn(['homeTeam','teamId'])+'.png',marginLeft:0.5,font:'narrowRegular',size:14,isCorriereCalendar:true,whiteSpace: false?'normal':''}),matchRow.get('status')==='PREMATCH'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:'0',font:'narrowBold',margin:isCup?'0px 7px':'0px 0 0 10px',className:'realTimeScore',size:1.1}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:this.homeResPen(),font:'narrowBold',margin:isCup?'0px 7px':'0px 0 0 10px',size:1.1,className:'realTimeScore'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentStart',md:12,sm:12,xs:12,style:{paddingLeft:'5%',paddingRight:'5%',height:'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{label:teamShortAway,color:'black',image:''+imagesURL+matchRow.getIn(['awayTeam','teamId'])+'.png',marginLeft:0.5,font:'narrowRegular',size:14,isCorriereCalendar:true,whiteSpace: false?'normal':''}),matchRow.get('status')==='PREMATCH'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:'0',font:'narrowBold',margin:isCup?'0px 7px':'0px 0 0 10px',size:1.1,className:'realTimeScore'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:this.awayResPen(),font:'narrowBold',margin:isCup?'0px 7px':'0px 0 0 10px',size:1.1,className:'realTimeScore'}))),isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* MatchRowDataContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,height:isMobile?'34px':'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{color:'black',image:''+imagesURL+matchRow.getIn(['homeTeam','teamId'])+'.png',marginLeft:0.5,font:'narrowRegular',size:15,isCorriereCalendar:true}),matchRow.get('status')==='PREMATCH'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:'0',font:'narrowBold',margin:'0px 2px 0px 6px',size:1.1,className:'realTimeScore'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:this.homeResPen(),font:'narrowBold',margin:'0px 2px 0px 6px',size:1.1,className:'realTimeScore'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,height:isMobile?'20px':'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{label:teamShortHome,color:'black',font:'narrowRegular',size:15,isCorriereCalendar:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,height:isMobile?'34px':'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{color:'black',image:''+imagesURL+matchRow.getIn(['awayTeam','teamId'])+'.png',marginLeft:0.5,font:'narrowRegular',size:15,isCorriereCalendar:true}),matchRow.get('status')==='PREMATCH'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:'0',font:'narrowBold',margin:'0px 2px 0px 6px',size:1.1,className:'realTimeScore'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_Label__["a" /* default */],{label:this.awayResPen(),font:'narrowBold',margin:'0px 2px 0px 6px',size:1.1,className:'realTimeScore'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{className:'flex justifyContentCenter',md:12,sm:12,xs:12,style:{paddingLeft:0,paddingRight:0,height:isMobile?'20px':'34px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_TeamLabel__["a" /* default */],{label:teamShortAway,color:'black',font:'narrowRegular',size:15,isCorriereCalendar:true}))))));}}]);return MatchRowBoxed;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MatchRowBoxed.propTypes={matchRow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isHighlight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,sportId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,competitionId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,dictionary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isCup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,trackString:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (MatchRowBoxed);

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MatchRowWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MatchRowDataContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MatchRowWrapperInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MatchLinkWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  background-color: #fff;\n  margin-top: 3px;\n  margin-bottom: 3px;\n  margin-right: 9px;\n  ','{\n    margin-right: 10px;\n    .generalBackground {\n      height: 20px;\n    }\n  };   \n  .boxTeam {\n    flex: ',';\n    line-height: 1;\n    width: ',';\n  }\n'],['\n  position: relative;\n  background-color: #fff;\n  margin-top: 3px;\n  margin-bottom: 3px;\n  margin-right: 9px;\n  ','{\n    margin-right: 10px;\n    .generalBackground {\n      height: 20px;\n    }\n  };   \n  .boxTeam {\n    flex: ',';\n    line-height: 1;\n    width: ',';\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 3px;\n  height: 33px;\n  ','{\n    height: 29px;\n    margin-top: 11px;\n  };\n'],['\n  display: flex;\n  flex-direction: column;\n  margin-top: 3px;\n  height: 33px;\n  ','{\n    height: 29px;\n    margin-top: 11px;\n  };\n']),_templateObject3=_taggedTemplateLiteral(['\n  box-sizing: border-box;\n  width: ',';\n  height: 90px;\n  ','{\n    width: ',';\n    height: 150px;\n  };\n  box-shadow: 0px 0px 4px 0 rgba(0,0,0,0.4);\n  border-radius: 4px;\n  overflow: hidden;\n'],['\n  box-sizing: border-box;\n  width: ',';\n  height: 90px;\n  ','{\n    width: ',';\n    height: 150px;\n  };\n  box-shadow: 0px 0px 4px 0 rgba(0,0,0,0.4);\n  border-radius: 4px;\n  overflow: hidden;\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  background-color: orange;\n  border: 1px solid orange;\n  border-radius: 50%;\n  height: 22px;\n  width: 22px;\n  ','{\n    height: 25px;\n    width: 25px;\n  }\n  font-size: 9px;\n  z-index: 30;\n  top: 14px;\n  right: 2px\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  white-space: pre-line;\n  word-spacing: 11px;\n  cursor: default;\n  color: black;\n  text-decoration: none;\n  margin-top: -20px;\n  font-family: ',';\n  ','{\n    right: 5px;\n    top: -4px;\n    margin-top: 0px;    \n  };\n'],['\n  position: absolute;\n  background-color: orange;\n  border: 1px solid orange;\n  border-radius: 50%;\n  height: 22px;\n  width: 22px;\n  ','{\n    height: 25px;\n    width: 25px;\n  }\n  font-size: 9px;\n  z-index: 30;\n  top: 14px;\n  right: 2px\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  white-space: pre-line;\n  word-spacing: 11px;\n  cursor: default;\n  color: black;\n  text-decoration: none;\n  margin-top: -20px;\n  font-family: ',';\n  ','{\n    right: 5px;\n    top: -4px;\n    margin-top: 0px;    \n  };\n']),_templateObject5=_taggedTemplateLiteral(['\n  ',';\n'],['\n  ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n    pointer-events: none !important;\n    cursor: default !important;\n  '],['\n    pointer-events: none !important;\n    cursor: default !important;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MatchRowWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;},function(props){return props.isMobile?'0':'3';},function(props){return props.isMobile?'auto':'50%';});var MatchRowDataContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;});var MatchRowWrapperInt=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(props){return props.isGazzanet?'140px':'145px';},function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;},function(props){return props.isGazzanet?'120px':'145px';});var GroupCircle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;},function(props){return props.theme.fontSets.BreraRegular;},function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;});var MatchLinkWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].a(_templateObject5,function(props){return props.disableLink&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6);});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IconFont__ = __webpack_require__(200);
var CorriereLink=function CorriereLink(_ref){var background=_ref.background,label=_ref.label,color=_ref.color,linkTo=_ref.linkTo,borderColor=_ref.borderColor,width=_ref.width,isTitleNarrowMedium=_ref.isTitleNarrowMedium,margin=_ref.margin,isBottomLink=_ref.isBottomLink,visibility=_ref.visibility;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonWrapper */],{background:background,href:linkTo,borderColor:borderColor,width:width,margin:margin,visibility:visibility},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ButtonLabel */],{color:color,isTitleNarrowMedium:isTitleNarrowMedium,className:'flex justifyContentEnd alignItemsCenter',isBottomLink:isBottomLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,label),!isBottomLink&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IconFont__["a" /* default */],{className:'icon-matchcenter-arrow-small',font:4,marginLeft:1,marginBottom:0.5,color:'lightBlue2'})));};CorriereLink.propTypes={label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,background:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,linkTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,borderColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isTitleNarrowMedium:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isBottomLink:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,visibility:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CorriereLink);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  &:link {\n    color: ',';\n    text-decoration: none;\n  }\n  &:visited {\n    color: ',';\n    text-decoration: none;\n  }\n  font-size: 12px;\n  ','{\n    font-size: 14px;\n  };\n  visibility: ',';\n'],['\n  &:link {\n    color: ',';\n    text-decoration: none;\n  }\n  &:visited {\n    color: ',';\n    text-decoration: none;\n  }\n  font-size: 12px;\n  ','{\n    font-size: 14px;\n  };\n  visibility: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: ',';\n  text-transform: uppercase;\n  margin-left: ',';\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: ',';\n  text-transform: uppercase;\n  margin-left: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].a(_templateObject,function(props){return props.theme.colors.lightBlue2;},function(props){return props.theme.colors.lightBlue2;},function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;},function(props){return props.visibility?props.visibility:'visibile';});var ButtonLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.theme.fontSets.BreraRegular;},function(props){return props.isBottomLink?'0px':'40px';});

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MainContainerCorriere; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DayStripWidgetWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrowContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MatchWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\nborder-top: 1px solid ',';\nbackground-color: #fff;\ndisplay: flex;\nflex-direction: row;\nwidth: 992px;\nmargin: auto;\n','{\n    padding: 0px;\n    width: 100%;\n    overflow: auto;\n    border-top: none;\n    border-bottom: none;\n};\n.resetLink, .resetLink:link, .resetLink:visited {\n    text-decoration: none !important;\n    display: inline;\n}\n'],['\nborder-top: 1px solid ',';\nbackground-color: #fff;\ndisplay: flex;\nflex-direction: row;\nwidth: 992px;\nmargin: auto;\n','{\n    padding: 0px;\n    width: 100%;\n    overflow: auto;\n    border-top: none;\n    border-bottom: none;\n};\n.resetLink, .resetLink:link, .resetLink:visited {\n    text-decoration: none !important;\n    display: inline;\n}\n']),_templateObject2=_taggedTemplateLiteral(['\npadding-top: 7px;\nwidth: 954px;\n','{\n    padding-bottom: 15px;\n    box-sizing: content-box;\n    width: 100%;\n    background-color: ',';\n    height: 227px;\n};\n\nwhite-space: nowrap;\nposition: relative;\n.flex {\n  display: flex;\n}\n.justifyContentStart {\n  justify-content: flex-start;\n}\n.justifyContentCenter {\n  justify-content: center;\n}\n.justifyContentEnd {\n  justify-content: flex-end;\n}\n.justifyContentBetween {\n  justify-content: space-between;\n}\n.alignItemsCenter {\n  align-items: center;\n}\n.LiveMainColorBackground {\n  background-color: ',';\n}\n.preMainColorBackground {\n  background-color: #DEDEDE;\n}\n'],['\npadding-top: 7px;\nwidth: 954px;\n','{\n    padding-bottom: 15px;\n    box-sizing: content-box;\n    width: 100%;\n    background-color: ',';\n    height: 227px;\n};\n\nwhite-space: nowrap;\nposition: relative;\n.flex {\n  display: flex;\n}\n.justifyContentStart {\n  justify-content: flex-start;\n}\n.justifyContentCenter {\n  justify-content: center;\n}\n.justifyContentEnd {\n  justify-content: flex-end;\n}\n.justifyContentBetween {\n  justify-content: space-between;\n}\n.alignItemsCenter {\n  align-items: center;\n}\n.LiveMainColorBackground {\n  background-color: ',';\n}\n.preMainColorBackground {\n  background-color: #DEDEDE;\n}\n']),_templateObject3=_taggedTemplateLiteral(['\ndisplay: flex;\njustify-content: center;\nflex-direction: column;\nalign-items: center;\npadding: 0px;\n'],['\ndisplay: flex;\njustify-content: center;\nflex-direction: column;\nalign-items: center;\npadding: 0px;\n']),_templateObject4=_taggedTemplateLiteral(['\nmax-width: 919px;\nmin-height: 110px;\nmargin-top: 14px;\nwidth: auto;\noverflow: hidden;\ndisplay: flex;\nwhite-space: nowrap;\njustify-content: flex-start;\n > a:last-child > div {\n  margin-right: 2px;\n }\n > a:first-child {\n  margin-left: 2px;\n }\n ','{\n    margin-bottom: 22px;\n    overflow: auto;\n    > a:last-child > div {\n      margin-right: 10px;\n    }\n    > a:first-child {\n      margin-left: 10px;\n    }\n  };\n'],['\nmax-width: 919px;\nmin-height: 110px;\nmargin-top: 14px;\nwidth: auto;\noverflow: hidden;\ndisplay: flex;\nwhite-space: nowrap;\njustify-content: flex-start;\n > a:last-child > div {\n  margin-right: 2px;\n }\n > a:first-child {\n  margin-left: 2px;\n }\n ','{\n    margin-bottom: 22px;\n    overflow: auto;\n    > a:last-child > div {\n      margin-right: 10px;\n    }\n    > a:first-child {\n      margin-left: 10px;\n    }\n  };\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MainContainerCorriere=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.theme.colors.gray2;},function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;});var DayStripWidgetWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;},function(props){return props.theme.colors.lightGray2;},function(props){return props.theme.colors.lightBlue2;});var ArrowContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3);var MatchWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.theme.mediaQueries.tablet_big_down_world_cup;});

/***/ })

});


// WEBPACK FOOTER //
// 20240314091842718.extra/chunks/7.505718b0.min.js